{
    "access-denied.description": "Ta kontakt med oss dersom du ønsker tilgang",
    "access-denied.title": "Her har du dessverre ikke tilgang",
    "archive-assignment.confirmation-modal.description": "Er du sikker på at du vil arkivere «{name}»?",
    "archive-assignment.confirmation-modal.labels.button.archive": "Arkiver {name}",
    "archive-assignment.confirmation-modal.title": "Arkiver oppdrag",
    "archive-customer.confirmation-modal.description": "Er du sikker på at du vil arkivere {name}?\nArkiverte kunder er ikke synlige i kundeoversikten.\nDu kan derimot benytte et visningsfilter for å finne dine arkiverte kunder.",
    "archive-customer.confirmation-modal.description.monitoring": "Ved å arkivere denne kunden vil den aktive monitoreringen avsluttes.\nEr du sikker på at du fortsatt vil arkivere {name}?\nArkiverte kunder er ikke synlige i kundeoversikten.\nDu kan derimot benytte et visningsfilter for å finne dine arkiverte kunder.",
    "archive-customer.confirmation-modal.labels.button.archive": "Arkiver {name}",
    "archive-customer.confirmation-modal.title": "Arkiver kunde",
    "assignment.selector.error.message": "Velg et oppdrag",
    "attachments.actions.delete-attachment": "Slett dokument",
    "attachments.actions.delete-signed-attachment": "Slett signert dokument",
    "attachments.actions.download-attachment": "Last ned dokument",
    "attachments.actions.download-signed-attachment": "Last ned signert dokument",
    "attachments.actions.edit-signature": "Valg for e-signatur",
    "attachments.actions.section.signed.document.title": "Signert dokument",
    "attachments.actions.signature.help-text": "E-signaturer er kun tilgjengelig for PDF-filer",
    "attachments.actions.view-signature": "Vis e-signatur",
    "attachments.cancel.confirmation.description": "Endringer er ikke lagret.\nVed å avbryte vil ikke de angitte motakerne få tilgang til signering av dokumentet",
    "attachments.cancel.confirmation.title": "Endringer ikke lagret",
    "attachments.cancel.confirmation.yes": "Avbryt og forkast endringer",
    "attachments.customer.upload.assignment.select": "Velg hvor du vil legge dokumentet",
    "attachments.delete.confirmation.description": "Er du sikker på at du ønsker å slette dokumentet {name} ?",
    "attachments.delete.confirmation.signed.description": "Er du sikker på at du har lyst til å slette det signerte dokumentet: {name}?\nSiden denne handlingen ikke kan angres, anbefaler vi deg å laste ned dokumentet før du sletter det.",
    "attachments.delete.confirmation.signed.title": "Slett signert dokument",
    "attachments.delete.confirmation.signed.yes": "Slett signert dokument",
    "attachments.delete.confirmation.title": "Slett dokument",
    "attachments.delete.confirmation.yes": "Slett dokument",
    "attachments.labels.empty": "Det er ingen opplastede dokumenter",
    "attachments.labels.loading": "Laster...",
    "attachments.labels.signature-status.expired": "Utgått",
    "attachments.labels.signature-status.not-activated": "(ikke aktivert)",
    "attachments.labels.signature-status.not-signed": "{signed} av {total} har signert",
    "attachments.labels.signature-status.pending": "Venter signatur",
    "attachments.labels.signature-status.signed": "Signert",
    "attachments.labels.signature-status.unsignable": "Usignerbar",
    "attachments.section.title": "Dokumenter",
    "attachments.section.title-with-signatures": "Dokumenter og e-signering",
    "attachments.signatures.modal.button.add-recipient": "Legg til mottaker",
    "attachments.signatures.modal.copy-link": "Kopier signeringslink",
    "attachments.signatures.modal.descriptions.unsignable-attachment": "Dokumentet som ble lastet opp kan ikke signeres og må lastes opp på nytt. Verifiser at dokumentet ikke er passordbeskyttet og at dokumentet ikke er ødelagt.",
    "attachments.signatures.modal.heading": "Mottakere",
    "attachments.signatures.modal.labels.automatic-email": "Automatisk e-post",
    "attachments.signatures.modal.labels.create-links": "Opprett link",
    "attachments.signatures.modal.labels.deleted-signed-document": "Signert dokument slettet av {name}, {date}",
    "attachments.signatures.modal.labels.email-sent": "E-post sendt",
    "attachments.signatures.modal.labels.missing-url": "Link er enda ikke opprettet",
    "attachments.signatures.modal.labels.national-id": "Verifiser fødselsnummer",
    "attachments.signatures.modal.labels.national-id.placeholder": "Mottakerens fødselsnummer ({maxDigits} sifre)",
    "attachments.signatures.modal.labels.saved-changes": "Endringer lagret",
    "attachments.signatures.modal.labels.send-emails-and-create-links": "Send e-post og opprett link",
    "attachments.signatures.modal.labels.unsaved-changes": "Endringer ikke lagret",
    "attachments.signatures.modal.labels.unsignable-attachment": "Dokumentet kan ikke signeres",
    "attachments.signatures.modal.name.placeholder": "Mottakerens navn",
    "attachments.signatures.modal.table.column.date-signed": "DATO SIGNERT",
    "attachments.signatures.modal.title": "Signatur på «{filename}»",
    "attachments.table.header.assignment": "OPPDRAG",
    "attachments.table.header.created.by": "LASTET OPP AV",
    "attachments.table.header.created.date": "LASTET OPP",
    "attachments.table.header.document": "DOKUMENT",
    "attachments.table.header.signature-status": "SIGNERINGSSTATUS",
    "attachments.table.messages.uploading": "Laster opp {count, plural, =1{} other {# dokumenter}}...",
    "attachments.upload.button": "Last opp dokument",
    "attachments.upload.button.available-file-types": "Disse filtypene støttes:",
    "auto-reminders-settings.description": "Kjenn Din Kunde kan automatisk varsle dine mottakere av legitimering- og KYC-forespørsler ved mangel på besvarelse. Påminnelsen sendes per e-post, og gjelder bare for mottakere som blir tilsendt forespørsel på e-post.",
    "auto-reminders-settings.form.label": "Når skal påminnelsen sendes?",
    "auto-reminders-settings.limit-options.label": "Hvor mange ganger skal vi sende automatisk påminnelse på e-post?",
    "auto-reminders-settings.page.title": "KYC-påminnelse",
    "auto-reminders-settings.send-options.bi-weekly": "Etter to uker",
    "auto-reminders-settings.send-options.custom": "Egendefinert",
    "auto-reminders-settings.send-options.custom.placeholder": "Antall dager",
    "auto-reminders-settings.send-options.not-set": "Ikke send automatiske påminnelser",
    "auto-reminders-settings.send-options.weekly": "Etter én uke",
    "badge.archived": "Arkivert",
    "badge.negative-news": "Negative nyheter",
    "badge.other": "Annet",
    "badge.pep": "PEP",
    "badge.sanctioned": "Sanksjon",
    "bulk.actions.add-to-existing-project.label": "Legg til i eksisterende prosjekt",
    "bulk.actions.add-to-new-project.label": "Legg til i nytt prosjekt",
    "bulk.actions.archive.confirmation.description": "Er du sikker på at du vil arkivere {names}?",
    "bulk.actions.archive.confirmation.title": "Arkiver kunder",
    "bulk.actions.archive.success.message": "{count, plural, =1 {kunde} other {# kunder}} arkivert",
    "bulk.actions.change-screening-type.label": "Screening-innstillinger",
    "bulk.actions.delete.confirmation.check": "Jeg bekrefter at jeg ønsker å slette de valgte kundene",
    "bulk.actions.delete.confirmation.description": "Du er i ferd med å slette markerte kunder permanent fra Kjenn Din Kunde.\nDette kan ikke reverseres.\nEr du helt sikker på at du vil slette: {names}? ",
    "bulk.actions.delete.confirmation.title": "Slett kunder",
    "bulk.actions.delete.success.message": "{count, plural, =1 {kunde} other {# kunder}} Slettet",
    "bulk.actions.followup.label": "Velg en oppfølgingsdato",
    "bulk.actions.followup.success.message": "Screening type endret",
    "bulk.actions.reject-match-cases.confirmation.description": "Er du sikker på at du vil avkrefte {count, number} treff?",
    "bulk.actions.reject-match-cases.confirmation.title": "Avkreft treff",
    "bulk.actions.reject-match-cases.success.message": "{count, number} treff avkreftet",
    "bulk.actions.responsible.label": "Velg ansvarlig",
    "bulk.actions.responsible.success.message": "Ansvarlige brukere endret",
    "bulk.actions.restore.confirmation.description": "Er du sikker på at du vil gjenopprette {names}?",
    "bulk.actions.restore.confirmation.title": "Gjenopprett kunder",
    "bulk.actions.restore.success.message": "{count, plural, =1 {kunde} other {# kunder}} gjenopprettet",
    "bulk.actions.screening-type.success.message": "Screening-innstillinger ble endret",
    "button.go.back": "Tilbake",
    "button.go.next": "Gå videre",
    "change-screening.buttons.save": "Endre screening",
    "change-screening.buttons.start-screening": "Start ny screening",
    "change-screening.buttons.stop-monitoring": "Stopp screening",
    "change-screening.stop-screening.description": "Du vil ikke lenger motta oppdateringer på eventuelle nye treff mot PEP, sanksjon og negative nyheter på personer som har vært under kontroll.",
    "change-screening.stop-screening.description-person": "Du vil ikke lenger motta oppdateringer på eventuelle nye treff mot PEP, sanksjon og negative nyheter på vedkommende.",
    "change-screening.stop-screening.title": "Er du sikker på at du vil stoppe screeningen?",
    "change-screening.titles.choose-screening-type": "Velg type screening",
    "change-screening.titles.new-screening": "Ny screening",
    "change-screening.titles.screening-owners": "Screening av rettighetshavere",
    "change-screening.titles.screening-person": "Screening utføres på",
    "change-screening.titles.screening-roles": "Screening av rolleinnehavere",
    "change-screening.titles.screening-title": "Endre screening",
    "common.address.addressline1": "Adresselinje 1",
    "common.address.addressline2": "Adresselinje 2",
    "common.address.city": "Poststed",
    "common.address.country": "Adresseland",
    "common.address.county": "Fylke",
    "common.address.postal.code": "Postnummer",
    "common.answered.label": "Besvart av {name}, {timestamp, date, ::yyyyMMdd}",
    "common.badge.new-info": "NY INFO",
    "common.banner.followup-expired.description": "Løpende oppfølging på denne kunden er satt til {followup, date, ::yyyyMMdd}. Gjør de nødvendige oppfølgingsrutinene, og legg igjen en ny vurdering av kunden.",
    "common.banner.followup-expired.title": "Kunden venter løpende oppfølging",
    "common.banner.possible.match.description": "Mulig treff på PEP, sanksjon eller negative nyheter.",
    "common.banner.possible.match.title": "Mulig treff",
    "common.buttons.action.edit": "Endre info",
    "common.buttons.actions.archive-assignment": "Arkiver oppdrag",
    "common.buttons.actions.archive-customer": "Arkiver kunde",
    "common.buttons.actions.button": "Handlinger",
    "common.buttons.actions.change-screening": "Endre screening",
    "common.buttons.actions.create-assignment": "Opprett oppdrag",
    "common.buttons.actions.delete-customer": "Slett kunde",
    "common.buttons.actions.download.report": "Last ned rapport",
    "common.buttons.actions.edit-assignment": "Rediger oppdragsdetaljer",
    "common.buttons.actions.edit-company-info": "Endre selskapsdetaljer",
    "common.buttons.actions.edit-person-info": "Endre persondetaljer",
    "common.buttons.actions.new-assignment": "Nytt oppdrag",
    "common.buttons.actions.new-assignment-disclosure": "Send KYC-spørsmål knyttet til oppdraget",
    "common.buttons.actions.new-disclosure": "Send KYC-spørsmål",
    "common.buttons.actions.new-screening": "Ny screening",
    "common.buttons.actions.restore-assignment": "Gjenopprett oppdrag",
    "common.buttons.actions.restore-customer": "Gjenopprett kunde",
    "common.buttons.actions.skip-step": "Hopp over dette steget",
    "common.buttons.move-down": "Flytt ned",
    "common.buttons.move-up": "Flytte opp",
    "common.country-select.choose-country-option": "Velg land",
    "common.date-input.placeholder": "dd/mm/åååå",
    "common.errors.company-external-id.exists": "En kunde med samme eksterne ID finnes allerede",
    "common.errors.company-national-id.exists": "En kunde med samme org.nr. finnes allerede",
    "common.errors.company.exists": "En tilsvarende selskapskunde finnes allerede",
    "common.errors.email.not-unique": "E-post eksisterer allerede",
    "common.errors.file-size-exceeded": "Opplastede filer kan ikke være større enn {max, number}mb. \nReduser størrelsen på filen og prøv igjen.",
    "common.errors.generic": "Noe gikk galt",
    "common.errors.generic.failed-action": "Kunne ikke {actionLabel} ({message})",
    "common.errors.invalid.account-number": "Feil i kontonummer. Sjekk at du har fått med alle 11 sifre.",
    "common.errors.invalid.address": "Ugyldig adresse",
    "common.errors.invalid.birth.date": "Ugyldig fødselsdato",
    "common.errors.invalid.citizenship": "Ugyldig statsborgerskap",
    "common.errors.invalid.comment": "Ugyldig kommentar",
    "common.errors.invalid.company.national-id": "Ugyldig org.nr.",
    "common.errors.invalid.email": "Ugyldig e-post",
    "common.errors.invalid.empty.mobile-phone": "Tomt mobilnummer",
    "common.errors.invalid.empty.name": "Tomt navn",
    "common.errors.invalid.empty.title": "Tom tittel",
    "common.errors.invalid.first.name": "Ugyldig fornavn",
    "common.errors.invalid.last.name": "Ugyldig etternavn",
    "common.errors.invalid.missing.last.name": "Mangler etternavn",
    "common.errors.invalid.name.exists": "Navnet finnes allerede",
    "common.errors.invalid.national-id.exists": "Fødselsnummer finnes allerede",
    "common.errors.invalid.person.national-id": "Ugyldig personnummer",
    "common.errors.invalid.person.national-id-country": "Velg land fra listen",
    "common.errors.person-external-id.exists": "En kunde med samme eksterne ID finnes allerede",
    "common.errors.person-national-id.exists": "En kunde med samme personnummer finnes allerede",
    "common.errors.person.exists": "En tilsvarende personkunde finnes allerede",
    "common.errors.required.first.name": "Fornavn påkrevd",
    "common.errors.required.last.name": "Etternavn påkrevd",
    "common.group.role.key.compliance-officer": "Etterlevelsesansvarlig",
    "common.group.role.key.kdk-admin": "Brukeradmin",
    "common.group.role.key.mlro": "Hvitvaskingsansvarlig",
    "common.labels.address": "Adresse",
    "common.labels.approve": "Godkjenn",
    "common.labels.approved": "Godkjent",
    "common.labels.archived-by": "Arkivert av {name}, {timestamp, date, ::yyyyMMdd}",
    "common.labels.bank-id": "BankID",
    "common.labels.birth_date": "Fødselsdato",
    "common.labels.both-customer-types": "Begge typer kunder",
    "common.labels.business-address": "Forretningsadresse",
    "common.labels.calculated-ubo": "Eierandelen indikerer at personen er å anse som reell rettighetshaver",
    "common.labels.change-seen": "Endring sett",
    "common.labels.citizenship": "Statsborgerskap",
    "common.labels.collapse-all": "Skjul alle",
    "common.labels.comment": "Kommentar",
    "common.labels.complete": "Fullfør",
    "common.labels.completed-by": "Fullført av {name}, {timestamp, date, ::yyyyMMdd}",
    "common.labels.confirmed-by": "Bekreftet av {name}, {timestamp, date, ::yyyyMMdd}",
    "common.labels.country": "Land",
    "common.labels.country-of-origin": "Fødeland",
    "common.labels.country-of-residence": "Bosteds/oppholdsland",
    "common.labels.create-tag": "Opprett Tag",
    "common.labels.created-by": "Opprettet av {name}, {timestamp, date, ::yyyyMMdd}",
    "common.labels.customer-relationship": "Kundeforhold",
    "common.labels.customer-type": "Velg hva slags type kunde(r) spørreskjemaet skal gjelde for:",
    "common.labels.customer-type.company": "Selskap",
    "common.labels.customer-type.person": "Person",
    "common.labels.customer.risk": "kunderisiko",
    "common.labels.description": "Beskrivelse",
    "common.labels.editorial-explanation": "Redaksjonell forklaring",
    "common.labels.email": "E-post",
    "common.labels.end-date": "Sluttdato",
    "common.labels.expand-all": "Utvid alle",
    "common.labels.file.upload": "Last opp fil",
    "common.labels.first_name": "Fornavn",
    "common.labels.go-to-support-page": "Gå til supportsiden",
    "common.labels.groups": "Grupper",
    "common.labels.include-assignment": "Inkluder oppdrag",
    "common.labels.kyc": "KYC",
    "common.labels.kyc-responses": "KYC-besvarelser",
    "common.labels.last_name": "Etternavn",
    "common.labels.manual-ubo": "Manuelt markert som reell rettighetshaver",
    "common.labels.mark-person-as-pep": "Personen er PEP",
    "common.labels.mark-person-as-sanctioned": "Personen er sanksjonert",
    "common.labels.missing-information": "Manglende informasjon",
    "common.labels.mobile-phone": "Mobilnummer",
    "common.labels.modified-by": "Sist endret av {name}, {timestamp, date, ::yyyyMMdd}",
    "common.labels.more-information-at": "Mer informasjon på vår",
    "common.labels.name": "Navn",
    "common.labels.national-id": "Fødselsnummer",
    "common.labels.national-id-country": "Land tilknyttet fødselsnummer",
    "common.labels.nationality": "Statsborgerskap",
    "common.labels.office-address": "Kontoradresse",
    "common.labels.pep-position-country": "Ansettelsesland for stillingen til PEP",
    "common.labels.photo": "Bilde",
    "common.labels.reject": "Avslå",
    "common.labels.rejected": "Avslått",
    "common.labels.rejected-by": "Avslått av {name}, {timestamp, date, ::yyyyMMdd}",
    "common.labels.risk-category.geographical": "Geografisk risiko",
    "common.labels.risk-category.industry": "Bransjerisiko",
    "common.labels.risk-category.pep": "PEP",
    "common.labels.risk-category.sanction": "Sanksjon",
    "common.labels.risk-response": "Risikobesvarelse",
    "common.labels.risk-type": "risikotype",
    "common.labels.save-changes": "Lagre endringer",
    "common.labels.save-settings": "Lagre innstillinger",
    "common.labels.saved-successfully": "Endringer lagret",
    "common.labels.selected-customers-count": "Markerte kunder: {count, number}",
    "common.labels.show-less": "Vis mindre",
    "common.labels.show-more": "Vis mer",
    "common.labels.show-more-with-count": "Vis fler ({count, number})",
    "common.labels.start-date": "Startdato",
    "common.labels.take-me-back": "Ta meg tilbake",
    "common.labels.title": "Tittel",
    "common.labels.triggered-when": "Trigges ved:",
    "common.labels.try-again": "Prøv igjen",
    "common.labels.ubo": "Reell rettighetshaver",
    "common.labels.unidentified-owner": "Uidentifisert eier",
    "common.language.english": "engelsk",
    "common.language.norwegian": "norsk",
    "common.loading.data": "Henter data",
    "common.month": "{months, plural, =1 {1 måned} other {# måneder}}",
    "common.multiple-names.full": "{fullnames} og {count, number} andre",
    "common.multiple-names.short": "{fullnames} og {lastname}",
    "common.reviewed.label": "Vurdert av {name}, {timestamp, date, ::yyyyMMdd}",
    "common.roles.ACCOUNTANT": "Regnskapsfører",
    "common.roles.ALTERNATE_BOARD_MEMBER": "Varamedlem",
    "common.roles.AUDITOR": "Revisor",
    "common.roles.BOARD_MEMBER": "Styremedlem",
    "common.roles.CEO": "Daglig leder",
    "common.roles.CHAIRMAN": "Styrets leder",
    "common.roles.COMPLEMENTARY": "Komplementar",
    "common.roles.CONTACT_PERSON": "Kontaktperson",
    "common.roles.DEPUTY_BOARD_MEMBER": "Varamedlem",
    "common.roles.DEPUTY_CHAIRMAN": "Nestleder",
    "common.roles.MANAGER": "Forretningsfører",
    "common.roles.MANAGING_DIRECTOR": "Bestyrende reder",
    "common.roles.NORWEGIAN_REPRESENTATIVE": "Norsk representant (NUF)",
    "common.roles.OBSERVER": "Observatør",
    "common.roles.PARTICIPANT_FULL_RESPONSIBILITY": "Deltaker med solidarisk ansvar (fullt ansvarlig)",
    "common.roles.PARTICIPANT_PART_RESPONSIBILITY": "Deltaker med proratarisk ansvar (delt ansvar)",
    "common.roles.PROCURA": "Prokura",
    "common.roles.PROCURA_JOINTLY": "Prokura i fellesskap",
    "common.roles.PROCURA_SEPARATELY": "Prokura hver for seg",
    "common.roles.PROPRIETOR": "Innehaver",
    "common.roles.REPRESENTATIVE": "Representant",
    "common.roles.SIGNATURE": "Signatur",
    "common.roles.SIGNATURE_JOINTLY": "Signatur i fellesskap",
    "common.roles.SIGNATURE_SEPARATELY": "Signatur hver for seg",
    "common.roles.TRUSTEE": "Bobestyrer",
    "common.roles.UNKNOWN_ROLE": "Ukjent rolle",
    "common.roles.not.in.use": "ikke i bruk",
    "common.roles.null": "Ukjent rolle",
    "common.share-class.CLASS_A": "A-AKSJER",
    "common.share-class.CLASS_B": "B-AKSJER",
    "common.share-class.CLASS_C": "C-AKSJER",
    "common.share-class.CLASS_D": "D-AKSJER",
    "common.share-class.CLASS_E": "E-AKSJER",
    "common.share-class.CLASS_F": "F-AKSJER",
    "common.share-class.CLASS_G": "G-AKSJER",
    "common.share-class.CLASS_H": "H-AKSJER",
    "common.share-class.CLASS_I": "I-AKSJER",
    "common.share-class.CLASS_J": "J-AKSJER",
    "common.share-class.EXTRAORDINARY_SHARES": "EKSTRAORDINÆRE AKSJER",
    "common.share-class.ISIN": "ISIN",
    "common.share-class.ORDINARY_SHARES": "ORDINÆRE AKSJER",
    "common.share-class.PREFERRED_SHARES": "PREFERANSE AKSJER",
    "common.share-class.UNKNOWN_SHARE_CLASS": "UKJENT AKSJEKLASSE",
    "common.vitec.synced": "Synkronisert til Vitec",
    "common.vitec.synchronize": "Synkroniser til Vitec",
    "common.year": "{years, number} år",
    "company-card.errors.fetch-failed-action": "Hente selskapsopplysninger",
    "company-form.headings.details": "Selskapsdetaljer",
    "company-form.labels.country": "Land",
    "company-form.labels.external-id": "Ekstern ID",
    "company-form.labels.name": "Selskapsnavn",
    "company-form.labels.national-id": "Org.nr.",
    "company.details.caption.address": "ADRESSE",
    "company.details.caption.address.postal": "POSTADRESSE",
    "company.details.caption.address.visit": "BESØKSADRESSE",
    "company.details.caption.closure_date": "Avslutningsdato",
    "company.details.caption.company.type": "ORGANISASJONSFORM",
    "company.details.caption.country": "LAND",
    "company.details.caption.employees": "ANSATTE",
    "company.details.caption.est": "ETABLERT",
    "company.details.caption.external-id": "ID",
    "company.details.caption.industry-codes": "NÆRINGSKODER",
    "company.details.caption.is_bankrupt": "KONKURS",
    "company.details.caption.name": "NAVN",
    "company.details.caption.national_id": "ORG.NR.",
    "company.details.caption.registered-in-foundation": "I STIFTELSESREGISTERET",
    "company.details.caption.registered-in-vat": "I MVA-REGISTERET",
    "company.details.caption.under_forced_liquidation": "UNDER TVANGSLIKVIDASJON ELLER OPPLØSNING",
    "company.details.caption.under_liquidation": "UNDER AVVIKLING",
    "company.details.caption.website": "HJEMMESIDE",
    "company.details.changes.tooltip.banner": "Endringer i selskapsdetaljer vises som «Ny» inntil det er markert som «Endring sett» eller det er foretatt en ny kundevurdering",
    "company.details.changes.tooltip.button.label": "Ny kundervurdering",
    "company.details.new-role.tooltip.banner": "Nye rolleinnehavere er markert som «Ny» inntil det er foretatt en endring på screeningen",
    "company.details.new-role.tooltip.button.label": "Endre screening",
    "company.details.onboarding.no-screening-performed": "Ingen screening gjennomført",
    "company.details.onboarding.title": "Disse er omfattet av screeningen",
    "company.details.screening.title": "hvem som er omfattet av screeningen",
    "company.details.title": "selskapsdetaljer",
    "company.owners.archive.description": "Er du sikker på at du vil arkivere: <bold>{name}</bold>?",
    "company.owners.hide-historical-owners": "Skjul historiske rettighetshavere",
    "company.owners.title": "Eierskapsinformasjon",
    "company.owners.view-historical-owners": "Vis historiske rettighetshavere",
    "company.owners.warning.foreign-company": "Aksjonærregisteret gir informasjon om at et selskap har eierandeler i din kunde, men informasjonen er mangelfull. Kontakt kunden for å få en oversikt over eierskaps- og kontrollstrukturen og reelle rettighetshavere.",
    "company.owners.warning.unidentified-owner": "Din kunde har eier(e) i eierstrukturen som ikke kan identifiseres fra Aksjonærregisteret. Kontakt kunden for å få en oversikt over eierskaps- og kontrollstrukturen og reelle rettighetshavere.",
    "company.roles.title": "Rolleinnehavere",
    "component.filter.country.title": "Land",
    "component.filter.customer.option.company.title": "Selskap",
    "component.filter.customer.option.person.title": "Person",
    "component.filter.customer.title": "Kunde",
    "component.filter.risk.title": "Kunderisiko",
    "component.filter.screening.title": "Type screening",
    "component.filters.all.title": "Alle",
    "component.filters.archive.option.include-archived-customers": "Vis arkiverte kunder",
    "component.filters.archive.title": "Arkiverte kunder",
    "component.filters.button.reset": "Nullstill",
    "component.filters.created-after.title": "Lagt til etter",
    "component.filters.created-before.title": "Lagt til før",
    "component.filters.created.applied.range.MONTH": "Lagt til den siste måneden",
    "component.filters.created.applied.range.WEEK": "Lagt til den siste uken",
    "component.filters.created.applied.range.YEAR": "Lagt til det siste året",
    "component.filters.created.labels.after": "Lagt til etter {date}",
    "component.filters.created.labels.before": "Lagt til før {date}",
    "component.filters.created.range.ALL": "Alle",
    "component.filters.created.range.CUSTOM": "Egendefinert tidsintervall",
    "component.filters.created.range.MONTH": "Siste måned",
    "component.filters.created.range.WEEK": "Siste uke",
    "component.filters.created.range.YEAR": "Siste år",
    "component.filters.created.title": "Lagt til",
    "component.filters.followup-after.title": "Oppfølging etter",
    "component.filters.followup-before.title": "Oppfølging før",
    "component.filters.followup-expired.title": "Oppfølging utløpt",
    "component.filters.followup.applied.range.MONTH": "Oppfølging neste måned",
    "component.filters.followup.applied.range.WEEK": "Oppfølging neste uke",
    "component.filters.followup.applied.range.YEAR": "Oppfølging om ett år",
    "component.filters.followup.labels.after": "Oppfølging til etter {date}",
    "component.filters.followup.labels.before": "Oppfølging til før {date}",
    "component.filters.followup.option.expired": "Oppfølging utløpt",
    "component.filters.followup.range.ALL": "Alle",
    "component.filters.followup.range.CUSTOM": "Egendefinert tidsintervall",
    "component.filters.followup.range.MONTH": "Neste måned",
    "component.filters.followup.range.WEEK": "Neste uke",
    "component.filters.followup.range.YEAR": "Neste år",
    "component.filters.followup.title": "Oppfølging",
    "component.filters.include.archive.title": "Inkluder arkiverte kunder",
    "component.filters.industry-type.title": "Bransjer",
    "component.filters.marked-as.option.pep": "PEP",
    "component.filters.marked-as.option.sanction": "Sanksjon",
    "component.filters.marked-as.title": "Markert som (PEP/Sanksjon)",
    "component.filters.match.option.open.matches": "Uvurderte treff",
    "component.filters.match.text.open.matches": "Har uvurderte treff",
    "component.filters.match.text.pep.matches": "Markert som PEP",
    "component.filters.match.text.sanction.matches": "Markert som sanksjon",
    "component.filters.ownership-updates.label": "Vis bare kunder med oppdatert informasjon fra Aksjonærregisteret",
    "component.filters.ownership-updates.title": "Oppdatering på eierforhold",
    "component.filters.pending-measures.option": "Har ventende tiltak",
    "component.filters.pending-measures.title": "Har ventende tiltak",
    "component.filters.project.option.active": "Aktivt",
    "component.filters.project.option.inactive": "Inaktiv",
    "component.filters.responsible.user.inactive": "Inaktiv",
    "component.filters.saved-filters.delete-filter": "Slett lagret filter",
    "component.filters.saved-filters.deleted.message": "Filter slettet",
    "component.filters.saved-filters.empty.message": "Legg til filtre i kundelisten og klikk “Lagre filter“ for å lagre",
    "component.filters.saved-filters.filter-name": "filter navn",
    "component.filters.saved-filters.my-customers": "Mine kunder",
    "component.filters.saved-filters.save-filters.label": "Lagre filter",
    "component.filters.saved-filters.saved.message": "Filtre lagret 🎉",
    "component.filters.saved-filters.title": "Lagrede filtre",
    "component.filters.saved-filters.without-filters": "Uten filter",
    "component.filters.screening.option.monitoring": "Løpende",
    "component.filters.screening.option.one-time": "Kun enkeltstående",
    "component.filters.status.approved": "Godkjent",
    "component.filters.status.draft-review": "Vurderingsutkast",
    "component.filters.status.not-ready": "Ikke vurdert",
    "component.filters.status.rejected": "Avslått",
    "component.filters.status.review-approval-required": "Venter bekreftelse på vurdering",
    "component.filters.status.review-required": "Klar for vurdering",
    "component.filters.status.started": "Påbegynt",
    "component.filters.status.title": "Status",
    "component.filters.tags.title": "Tags",
    "component.filters.text.and": "og",
    "component.filters.unresolved-matched.title": "Treff",
    "component.notes.delete.confirmation.description": "Er du sikker på at du ønsker å slette notaten?",
    "component.notes.delete.confirmation.title": "Slett notat",
    "component.notes.labels.save-note": "Lagre notat",
    "component.notes.title": "Notater {count, plural, =0 {} other {(#)}}",
    "component.pagination.labels.select-limit": "Vis {limit} kunder",
    "component.pagination.labels.showing": "Viser {start, number} - {end, number} av {count, number}",
    "component.questionnaires-list.empty": "Dere har ikke opprettet noen egne KYC-spørsmål. Det kan opprettes [her]({link}).  \nPS. Det er Hvitvaskingsansvarlig / Etterlevelsesansvarlig i deres selskap som oppretter dette i Innstillinger.",
    "component.questionnaires-list.filter.label": "Filtrer egendefinerte spørreskjemaer:",
    "component.questionnaires-list.loading": "Laster egendefinerte spørreskjemaer",
    "component.questionnaires-list.loading.error-action": "Hente egendefinerte spørreskjema",
    "component.review.checklist.added.toast.message": "Ny sjekkliste lagt til.",
    "component.review.checklist.added.toast.scroll.label": "Se sjekklisten",
    "component.review.checklist.create-instance": "Bruk mal",
    "component.review.checklist.form.remove.confirmation.description": "Er du sikker på at du vil fjerne «{name}»?",
    "component.review.checklist.form.remove.confirmation.title": "Slett sjekkliste",
    "component.review.checklist.select.button.label.add": "Legg til sjekkliste",
    "component.review.checklist.select.checklists-list.filter.label": "Filtrer egendefinerte sjekklister:",
    "component.review.checklist.select.checklists-list.loading": "Laster egendefinert sjekkliste",
    "component.review.checklist.select.checklists-list.loading.error": "Noe gikk galt ved henting av sjekklister",
    "component.review.checklist.template.title": "Velg mal",
    "component.search.customers.hint": "Søk på kunde",
    "component.users-list.all-users.title": "Alle Brukere",
    "component.users-list.filter.label": "Filtrer brukere:",
    "component.users-list.loading": "Laster brukere",
    "component.users-list.loading.error-action": "Hente brukere",
    "copy-label.buttons.copy.tooltip": "Kopier til utklippstavle",
    "customer-assignments.completed": "Fullført",
    "customer-assignments.details.assignment-description": "Oppdragsbeskrivelse",
    "customer-assignments.details.assignment-industry-type": "Oppdragets bransje",
    "customer-assignments.details.assignment-purpose": "Oppdragstype",
    "customer-assignments.details.assignment-risk": "Oppdragsrisiko",
    "customer-assignments.empty": "Det er ikke registrert noen oppdrag på denne kunden.",
    "customer-assignments.list.filter.hide-archived-assignments": "Skjul arkiverte oppdrag ({count, number})",
    "customer-assignments.list.filter.show-archived-assignments": "Vis arkiverte oppdrag ({count, number})",
    "customer-assignments.list.header.added": "LAGT TIL",
    "customer-assignments.list.header.name": "TITTEL",
    "customer-assignments.list.header.responsible": "ANSVARLIG BRUKERE",
    "customer-assignments.list.header.risk": "OPPDRAGSRISIKO",
    "customer-assignments.list.header.status": "STATUS",
    "customer-assignments.modal.assignment-description": "Oppdragsbeskrivelse",
    "customer-assignments.modal.assignment-industry": "Bransje som oppdraget tilhører (valgfritt)",
    "customer-assignments.modal.assignment-industry.placeholder": "Velg en bransje fra listen",
    "customer-assignments.modal.assignment-name": "Oppdragsnavn",
    "customer-assignments.modal.assignment-purpose": "Oppdragstype (valgfritt)",
    "customer-assignments.modal.assignment-purpose.placeholder": "Velg fra liste eller definer et nytt formål",
    "customer-assignments.modal.assignment-purpose.placeholder-without-description": "Velg formål fra liste",
    "customer-assignments.no-disclosures.text": "Det er ingen KYC-forespørsler knyttet til dette oppdraget.",
    "customer-assignments.no-disclosures.title": "Send KYC-forespørsler knyttet til dette oppdraget ved å trykke på knappen under.",
    "customer-assignments.review.button.action": "Vurder oppdrag",
    "customer-assignments.review.button.change": "Oppdater risikovurdering",
    "customer-assignments.review.not-reviewed": "Oppdraget har ikke blitt vurdert",
    "customer-assignments.review.status.pending": "Venter vurdering",
    "customer-assignments.review.status.waiting": "Venter legitimering",
    "customer-assignments.review.title": "Risikovurdering av oppdrag",
    "customer-assignments.title": "Oppdrag",
    "customer-notifications-settings.description": "Velg hvor ofte du vil motta oppdateringer på selskapsinformasjon fra Enhetsregisteret. Velg <bold>umiddelbart</bold> dersom du ønsker e-post for hver selskapsoppdatering, velg <bold>daglig</bold> dersom du ønsker e-post som samler opp daglige oppdateringer, velg <bold>ukentlig</bold> dersom du ønsker e-post som samler opp ukentlige oppdateringer.",
    "customer-notifications-settings.frequency.label": "Hvor ofte vil du motta varsling på e-post?",
    "customer-notifications-settings.frequency.options.daily": "Daglig",
    "customer-notifications-settings.frequency.options.immediately": "Umiddelbart",
    "customer-notifications-settings.frequency.options.weekly": "Ukentlig",
    "customer-notifications-settings.page.title": "Oppdateringer på selskapsinformasjon",
    "customer-projects.empty": "Ingen prosjekter funnet",
    "customer-review-assignment.labels.include-assignment": "Velg hva risikovurderingen gjelder",
    "customer-review-guideline-settings.labels.guideline.header": "Overskrift",
    "customer-review-guideline-settings.page.description": "Dersom du ønsker å lage dine egne rutiner for kundevurdering kan du endre på teksten under. Du kan når som helst endre tilbake til den opprinnelige teksten ved å tilbakestille. PS. Velger du å tilbakestille, gjelder dette på både person og selskapskunder.",
    "customer-review-guideline-settings.page.reset.confirmation.description": "Er du sikker på at du vil tilbakestille til den opprinnelige teksten fra systemet?\nDette vil slette endringene du har gjort både på personkunder og selskapskunder.",
    "customer-review-guideline-settings.page.reset.confirmation.title": "Tilbakestill rutiner for kundevurdering",
    "customer-review-guideline-settings.page.title": "Rutiner for kundevurdering",
    "customer.checklist.review.form.header": "Sjekklister",
    "customer.details.archived-date": "Arkivert av {name}, {timestamp, date, ::yyyyMMdd}",
    "customer.notes.placeholder": "Legg igjen notater om kunden",
    "customers.list.column.added": "LAGT TIL",
    "customers.list.column.customer": "KUNDE",
    "customers.list.column.customers.count": "ANTALL KUNDER",
    "customers.list.column.external-id": "ID",
    "customers.list.column.report": "RAPPORT",
    "customers.list.column.responsible.users": "ANSVARLIG BRUKER",
    "customers.list.column.risk": "KUNDERISIKO",
    "customers.list.column.tasks": "OPPGAVER",
    "customers.list.empty.content": "Det var ingen kunder som matchet søket og/eller filtervalgene dine",
    "customers.list.empty.title": "Søket ditt ga ingen treff",
    "customers.list.external-id.tooltip": "Ekstern ID: {id}",
    "customers.list.fresh-customer.content": "Da er det vel på tide å komme i gang!",
    "customers.list.fresh-customer.label": "Nå er jeg klar!",
    "customers.list.fresh-customer.title": "Har du ikke lagt inn noen kunder ennå?",
    "customers.list.header.customers.count": "Antall kunder: {count, number} {selected, plural, =0 {} other {(# valgt)}}",
    "customers.list.header.customers.count.all": "Antall kunder: {count, number} (alle valgt)",
    "customers.list.header.selected.count": "{count} valgt",
    "customers.list.paging.limit.select.label": "Vis {limit} kunder",
    "customers.list.paging.next": "Neste",
    "customers.list.paging.previous": "Forrige",
    "customers.list.paging.showing": "Viser {start} - {end} av {count}",
    "customers.list.tabs.labels.all": "Alle kunder ({count, number})",
    "customers.list.tabs.labels.pending-tasks": "Kunder med utestående oppgaver",
    "customers.list.title": "Kunder",
    "dashboard.filters.date.from": "Fra: {date}",
    "dashboard.filters.date.interval.ANNUALLY": "Siste år",
    "dashboard.filters.date.interval.CUSTOM_DATE_RANGE": "Egendefinert tidsintervall",
    "dashboard.filters.date.interval.DAILY": "Siste dag",
    "dashboard.filters.date.interval.MONTHLY": "Siste måned",
    "dashboard.filters.date.interval.QUARTERLY": "Siste kvartal",
    "dashboard.filters.date.interval.WEEKLY": "Siste uke",
    "dashboard.filters.date.title": "Tidsintervall",
    "dashboard.filters.date.until": "Til: {date}",
    "dashboard.widgets.active-customers.title": "Mine kunder",
    "dashboard.widgets.industry-types.empty.message": "Ingen bransjer funnet",
    "dashboard.widgets.industry-types.filter.placeholder": "Filtrer på bransjer",
    "dashboard.widgets.industry-types.title": "Bransje",
    "dashboard.widgets.marked-as-pep.title": "Kunder med PEP status",
    "dashboard.widgets.marked-as-sanctioned.title": "Sanksjonerte kunder",
    "dashboard.widgets.pending-tasks.title": "Kunder med utestående oppgaver",
    "dashboard.widgets.risk-data.PEP": "Politisk Eksponert Person",
    "dashboard.widgets.risk-data.by.assignment.title": "AML-rapportering for eiendomsmeglingsvirksomheter - oppdrag importert fra Vitec Next",
    "dashboard.widgets.risk-data.by.assignment.tooltip": "Tallene er linket mot oppdrag importert fra Vitec Next, og inkluderer arkiverte oppdrag.\n\nTallene er hentet fra KYC-besvarelse(r), med unntak av PEP-status og tilknytning til høyrisikoland.\n\nPEP-status avhenger av om en kunde i oppdraget er markert som PEP i Kjenn Din Kunde.\n\nTilknytning til høyrisikoland er en kombinasjon av informasjon registrert i Kjenn Din Kunde og KYC-besvarelse.",
    "dashboard.widgets.risk-data.by.customer.title": "AML-rapportering for eiendomsmeglingsvirksomheter - tall per kunde",
    "dashboard.widgets.risk-data.by.customer.tooltip": "Tallene inkluderer alle kunder som har besvart minst ett KYC-skjema, og inkluderer arkiverte kunder.\n\nTallene er hentet fra KYC-besvarelse(r), med unntak av PEP-status og tilknytning til høyrisikoland.\n\nPEP-status avhenger av om kunden er markert som PEP i Kjenn Din Kunde.\n\nTilknytning til høyrisikoland er en kombinasjon av informasjon registrert i Kjenn Din Kunde og KYC-besvarelse.",
    "dashboard.widgets.risk-data.construction-industry": "Bransjetilhørighet i bygg- og anleggsbransjen",
    "dashboard.widgets.risk-data.financed-crowdfunding": "Finansiert av folkefinansiering",
    "dashboard.widgets.risk-data.financed-crypto": "Finansiert av kryptovaluta eller kryptokunst",
    "dashboard.widgets.risk-data.high-risk-country": "Tilknytning til høyrisikoland",
    "dashboard.widgets.risk-data.high-risk-industry": "Bransjetilhørighet innen andre høyrisikobransjer",
    "dashboard.widgets.risk-data.missing-funding-documentation": "Renovert med finansiering av ukjent opprinnelse",
    "dashboard.widgets.risk-data.missing-work-documentation": "Renovert hele/deler uten faktura",
    "dashboard.widgets.risk-levels.title": "Risikonivå - alle kunder",
    "dashboard.widgets.status.title": "Status kundeforhold",
    "default.add": "Legg til",
    "default.archive": "Arkiver",
    "default.cancel": "Avbryt",
    "default.categories": "kategorier",
    "default.change": "Endring",
    "default.close": "Lukk",
    "default.confirm": "Bekreft",
    "default.copy": "Kopiér",
    "default.create": "Opprett",
    "default.days": "{days, plural, =1 {dag} other {dager}}",
    "default.delete": "Slett",
    "default.down-from": "Ned fra {value}",
    "default.edit": "Rediger",
    "default.email": "E-post",
    "default.expired": "Utgått",
    "default.hide": "Skjul",
    "default.history": "historikk",
    "default.home": "Hjem",
    "default.inactive": "Inaktiv",
    "default.industries": "bransjer",
    "default.invalid": "Ugyldig",
    "default.keep": "Behold",
    "default.link": "Link",
    "default.loading": "Laster",
    "default.mandatory": "Obligatorisk",
    "default.months": "{months, plural, =1 {måned} other {måneder}}",
    "default.new": "Ny",
    "default.next": "Neste",
    "default.no": "Nei",
    "default.normal": "Normalt",
    "default.or": "eller",
    "default.preview": "Forhåndsvis",
    "default.previous": "Forrige",
    "default.reject": "Avkreft",
    "default.remove": "Slett",
    "default.required": "Påkrevd",
    "default.reset": "Tilbakestill",
    "default.restore": "Gjenopprett",
    "default.risk": "Risiko",
    "default.save": "Lagre",
    "default.save-changes": "Lagre endringer",
    "default.search": "Søk",
    "default.send": "Send",
    "default.show": "Vis",
    "default.status": "Status",
    "default.support-portal": "supportportal",
    "default.times": "{count, plural, =1 {ganger} other {# ganger}}",
    "default.unknown": "Ukjent",
    "default.up-from": "Opp fra {value}",
    "default.view": "Utsikt",
    "default.years": "{years, plural, =1 {år} other {år}}",
    "default.yes": "Ja",
    "delete-customer.confirmation-modal.description": "Du er i ferd med å slette {name} permanent fra Kjenn Din Kunde.\nDette kan ikke reverseres.\nEr du helt sikker på at du vil slette denne kunden?",
    "delete-customer.confirmation-modal.labels.button.delete": "Slett {name}",
    "delete-customer.confirmation-modal.success.message": "{name} slettet",
    "delete-customer.confirmation-modal.title": "Slett kunde",
    "details.banners.critical-update.content": "Det har skjedd endringer på selskapet som kan medføre konsekvenser for kundeforholdet.",
    "details.banners.critical-update.title": "Selskapsendringer som kan medføre konsekvenser",
    "details.banners.ownership-updates.content": "Vi har fått oppdatert informasjon fra Aksjonærregisteret, og har derfor ny informasjon på rettighetshavere tilhørende denne kunden.",
    "details.banners.ownership-updates.link-label": "Se oppdateringene",
    "details.banners.screening.in.progress.content": "Venter på resultater fra screeningen",
    "details.banners.screening.in.progress.title": "Screening pågår",
    "details.basic-info.customer-risk": "Kunderisiko",
    "details.basic-info.follow-up": "Løpende oppfølging",
    "details.basic-info.marked-as": "Markert som",
    "details.basic-info.screening-type": "Type screening",
    "details.basic-info.status": "Kundeforhold",
    "details.reviews.approved-by": "Oppdatert av: ",
    "details.reviews.assignment-review.accepted": "Oppdrag vurdert",
    "details.reviews.assignment-review.rejected": "Oppdrag avslått",
    "details.reviews.awaiting-approval": "Venter bekreftelse",
    "details.reviews.awaiting-approval-with-names": "Venter bekreftelse av {names}",
    "details.reviews.awaiting-measures": "Venter utførelse av tiltak",
    "details.reviews.confirm.approve": "Godkjenn vurdering",
    "details.reviews.confirm.approve-reject.title": "Begrunnelse",
    "details.reviews.confirm.cancel.description": "Er du sikker på at du vil avbryte endringene?",
    "details.reviews.confirm.cancel.title": "Avbryt endringer",
    "details.reviews.confirm.delete.description": "Er du sikker på at du vil slette denne vurderingen?\n(Denne handlingen kan ikke angres)",
    "details.reviews.confirm.delete.title": "Slette vurderingen",
    "details.reviews.confirm.reject": "Avslå vurdering",
    "details.reviews.confirm.reject.description": "Ved å avslå vurderingen må gjøres på nytt av den ansatte.",
    "details.reviews.confirmed-by": "Bekreftet av: ",
    "details.reviews.customer-review.accepted": "Kundeforhold godkjent",
    "details.reviews.customer-review.rejected": "Kundeforhold avslått",
    "details.reviews.draft": "Vurderingsutkast",
    "details.reviews.labels.cancel": "Ja, avbryt",
    "details.reviews.labels.confirm-delete": "Ja, slett vurdering",
    "details.reviews.labels.delete": "Slett vurdering",
    "details.reviews.labels.save-and-continue": "Lagre og fortsett senere",
    "details.reviews.measures.comment.label": "Utførte tiltak:",
    "details.reviews.measures.edit-measure": "Utfør tiltak",
    "details.reviews.measures.form.completed.label": "Har tilstrekkelige tiltak blitt utført?",
    "details.reviews.measures.form.description.label": "Beskriv utførte tiltak",
    "details.reviews.measures.form.description.placeholder": "Dokumenter resultatet fra utført tiltak",
    "details.reviews.measures.header": "Tiltak",
    "details.reviews.measures.remove-confirmation.description": "Er du sikker på at du vil fjerne «{name}»?",
    "details.reviews.measures.remove-confirmation.title": "Slett tiltak",
    "details.reviews.messages.saved": "Vurderingen er lagret",
    "details.reviews.pending-measures": "Vurderingen er ikke ansett ferdig før alle tiltakene er blitt utført",
    "details.reviews.rejected-by": "Avslått av: ",
    "details.reviews.reviewed-by": "Vurdert av: ",
    "details.reviews.risk-set-from-x-to-y": "Kunderisiko endret fra {beforeRisk} til {risk}",
    "details.reviews.risk-set-to-x": "Kunderisiko satt til {risk}",
    "disclosure-card.completed.subtitle": "Fullført {timestamp, date, ::yyyyMMdd}",
    "disclosure-card.content-language": "INNHOLDSSPRÅK",
    "disclosure-card.date-tile": "DATO OPPRETTET",
    "disclosure-card.email-tile": "E-POSTADRESSE",
    "disclosure-card.expired-banner.description": "Det vil ikke sendes ut flere automatiske påminnelser. Du må nå sende påminnelse manuelt, eller kontakte kunden direkte.",
    "disclosure-card.expired-banner.title": "Manglende besvarelse",
    "disclosure-card.identification.label": "Identifisert person ({method})",
    "disclosure-card.link-tile": "LINK",
    "disclosure-card.next-notification.subtitle": "Neste påminnelse sendes: {timestamp, date, ::yyyyMMdd}",
    "disclosure-card.notified.subtitle": "Påminnelse sendt: {timestamp, date, ::yyyyMMdd}",
    "disclosure-card.pin-tile": "PIN",
    "disclosure-card.recipient-tile": "MOTTAKER",
    "disclosure-card.scope-tile": "INKLUDERT",
    "disclosure-card.status-tile": "STATUS",
    "disclosure-collapsible.hide": "Skjul besvarelse",
    "disclosure-collapsible.show": "Vis besvarelse",
    "disclosure-documents.empty": "Ingen forespørsler sendt",
    "disclosure-documents.title": "KYC-spørsmål og legitimering",
    "disclosure-request.banner.no.signing-basis": "Signeringsgrunnlag finnes ikke",
    "disclosure-request.banner.signatory-rights": "Signaturrett i {company}",
    "disclosure-request.button.add-representative": "Legg til representant",
    "disclosure-request.button.send": "Opprett forespørsel",
    "disclosure-request.column.content-language": "Innholdsspråk",
    "disclosure-request.column.custom-questionnaires": "Legg til egne KYC-spørsmål",
    "disclosure-request.column.customer": "Kunde",
    "disclosure-request.column.email": "E-postadresse",
    "disclosure-request.column.sending-method": "Sendemetode",
    "disclosure-request.field.email.placeholder": "Mottakerens e-postadresse",
    "disclosure-request.field.use_pep_disclosure": "Kun PEP-spørsmål",
    "disclosure-request.field.use_standard_disclosure": "KYC-spørsmål (inkl. PEP-spørsmål)",
    "disclosure-request.field.use_verification": "Legitimering (BankID)",
    "disclosure-request.title": "Send forespørsel om legitimasjon og KYC-spørsmål",
    "disclosure-request.toggle.automatic-email": "Send e-post",
    "disclosure-status.completed": "Fullført",
    "disclosure-status.expired": "Utgått",
    "disclosure-status.waiting": "Venter besvarelse",
    "disclosure-status.warning": "Oppdaget {count, plural, =1 {1 høyrisikobesvarelse} other {# høyrisikobesvarelser}}",
    "disclosure.fileset.document-type.ARTICLES_OF_ASSOCIATION": "Vedtekter",
    "disclosure.fileset.document-type.COMPANY_STRUCTURE": "Selskapsstruktur",
    "disclosure.fileset.document-type.FAMILY_OWNERSHIP": "Beskrivelse av familiens felles eierskap",
    "disclosure.fileset.document-type.HOMEOWNER_AGREEMENT": "Avtale med hjemmelshaver",
    "disclosure.fileset.document-type.HOMEOWNER_POWER_OF_ATTORNEY": "Fullmakt",
    "disclosure.fileset.document-type.POWER_OF_ATTORNEY": "Fullmakt",
    "disclosure.fileset.document-type.PRIVATE_LOAN_AGREEMENT": "Låneavtale",
    "disclosure.fileset.document-type.PRIVATE_LOAN_AGREEMENT_DEVELOPED_PROPERTY": "Låneavtale",
    "disclosure.fileset.document-type.PROPERTY_OWNERSHIP_STRUCTURE": "Eierforhold/eierbrøk",
    "disclosure.fileset.document-type.SHAREHOLDER_BOOK": "Aksjeeierbok",
    "disclosure.fileset.document-type.UBO_AGREEMENT": "Aksjonæravtale",
    "disclosure.fileset.document-type.UPGRADE_FUNDING_DOCUMENTATION": "Dokumentasjon på finansiering",
    "disclosure.fileset.document-type.UPGRADE_WORK_DOCUMENTATION": "Dokumentasjon på utført arbeid",
    "disclosure.foreign-assignment-description": "Andre land enn Norge som er involvert i oppdraget",
    "disclosure.settings.page.description": "Tilpass innholdet som sendes dine kunder på e-post (innhenting av legitimering og KYC), slik at det blir mer personlig. Du har mulighet til å laste opp egen logo, samt skrive en egendefinert tekst som vises i e-posten. (Logoen deres vil også være synlig på spørreskjemaer som opprettes og sendes som link.)",
    "disclosure.settings.page.labels.email.due-diligence.identification": "Legitimering med BankID",
    "disclosure.settings.page.labels.email.due-diligence.kyc": "Spørsmål relevant for kundeforholdet",
    "disclosure.settings.page.labels.email.due-diligence.list.title": "Bakgrunnsundersøkelsen inneholder:",
    "disclosure.settings.page.labels.email.header": "Hei, (Navn på kunde).",
    "disclosure.settings.page.labels.email.subject.company": "SELSKAPSNAVN gjennomfører en kundekontroll av SLUTTKUNDESELSKAP",
    "disclosure.settings.page.labels.email.subject.person": "SELSKAPSNAVN gjennomfører en kundekontroll",
    "disclosure.settings.page.labels.logo": "Last opp egen logo",
    "disclosure.settings.page.labels.supported-filetypes": "Du kan laste opp .jpg eller .png (opp til {limit} KB)",
    "disclosure.settings.page.labels.text": "Legg til egen tekst i e-post",
    "disclosure.settings.page.tabs.customer-type.company": "Selskapskunder",
    "disclosure.settings.page.tabs.customer-type.person": "Personkunder",
    "disclosure.settings.page.title": "Egen logo og tekst",
    "disclosure.source-of-funds": "Midlenes opprinnelse",
    "disclosure.timestamp": "Besvart",
    "disclosure.ubo-agreements-description": "Informasjon om avtale(r) og hvilke(n) person(er) som har reell kontroll over selskapet",
    "disclosure.ubo-agreements-exists": "Foreligger det vedtekter, aksjonæravtale(r) eller annen avtale som har bestemmelser om hvem som i realiteten (direkte eller indirekte) kontrollerer selskapet?",
    "disclosure.ubo-company-control.heading": "Spørsmål om reelle rettighetshavere og selskapskontroll",
    "disclosure.ubo-company-structure-description": "Informasjon om selskapsstrukuren i selskapet",
    "disclosure.ubo-company-structure-exists": "Er selskapet du handler på vegne av, en del av en selskapsstruktur?",
    "disclosure.ubo-family-members-description": "Informasjon om familiemedlemmer som til sammen utøver reell kontroll over selskapet",
    "disclosure.ubo-family-members-exists": "Er det familiemedlemmer som til sammen (direkte eller indirekte) innehar mer enn 25% av aksjene/stemmene eller til sammen utøver reell kontroll over selskapet?",
    "disclosure.ubo-share-classes-description": "Informasjon om aksjeklasser i selskapet",
    "disclosure.ubo-share-classes-exists": "Er det flere aksjeklasser i selskapet du handler på vegne av?",
    "disclosure.ubo-structure-changes-description": "Informasjon om endringer i eierstrukturen",
    "disclosure.ubo-structure-changes-exists": "Har det skjedd endringer i eierstrukturen?",
    "disclosure.usage-of-funds": "Hvordan skal midlene etter salget benyttes?",
    "display-name.suffixes.labels.birth-date": "(f. {birthDate, date, ::yyyy})",
    "display-name.suffixes.labels.org-id": "(org.nr. {orgId})",
    "email.invalid.address.error": "Ugyldig adresse",
    "email.placeholder.text": "Skriv inn e-postadresse",
    "email.required.error": "E-postadresse påkrevd",
    "error.message.unknown": "Det oppstod en feil",
    "error.page.description": "Gi det noen sekunder og prøv igjen",
    "error.page.title": "Det har dessverre skjedd en feil ...",
    "expired.actions.logout": "Logg inn",
    "expired.description": "Av sikkerhetsmessige hensyn logges du ut etter 30 minutter (hvis du ikke er aktiv)",
    "expired.heading": "Du må logge inn på nytt",
    "fetch.identification.info.card.note": "Dette er videre beskrevet i kapittel 4.3 i Finanstilsynets veileder til hvitvaskingsloven.",
    "fetch.identification.info.card.text": "Rapporteringspliktige foretak underlagt hvitvaskingsloven er i henhold til §12 i lov om tiltak mot hvitvasking og terrorfinansiering pliktig til innhente legitimasjon fra kunder når dette er en fysisk person, samt for fysiske personer som handler på vegne av et foretak.",
    "fetch.identification.info.card.title": "Hvorfor må man innhente legitimasjon?",
    "followup-notifications.settings.intervals.description": "Velg hvor ofte du vil motta varsling om ventende/utløpte oppfølginger på e-post. E-posten inneholder link til Kjenn Din Kunde med filtervisning på kundene som du skal følge opp.",
    "followup-notifications.settings.page.title": "Kundeoppfølging intervall",
    "followup-settings.intervals.description": "Du kan definere oppfølgingsintervall for hvert risikonivå. Når oppfølgingsdatoen for en kunde utløper, endres kundens status til \"venter oppfølging\". Kunden må da risikovurderes på nytt. Merk at du også kan sette en egendefinert oppfølgingsdato for en kunde fra kundesiden.",
    "followup-settings.intervals.labels.custom-interval": "Egendefinert intervall",
    "followup-settings.intervals.labels.custom-interval.placeholder": "Antall måneder",
    "followup-settings.intervals.labels.no-interval": "Ingen intervall",
    "followup-settings.page.link-to-notifications": "PS. Under <link> kan du definere hvor ofte du vil motta varsling på e-post om ventende/utløpte oppfølginger.",
    "followup-settings.page.title": "Kundeoppfølging",
    "followup.modal.labels.date": "Velg en ny oppfølgingsdato",
    "followup.modal.message": "Angi oppfølgingsdato for {names}",
    "followup.modal.title": "Angi oppfølgingsdato",
    "followup.select.empty.label": "Velg oppfølgingsdato",
    "followup.select.error-action": "Angi oppfølgingsdato",
    "followup.select.expired.label": "Utløpt: {followup, date, ::yyyyMMdd}",
    "followup.select.label": "Neste: {followup, date, ::yyyyMMdd}",
    "followup.select.success.message": "Oppfølgingsdato ble endret",
    "followup.select.title": "Egendefinert dato på neste oppfølging",
    "high-risk-countries.list.EU": "EU",
    "high-risk-countries.list.EU_TAX_HAVEN": "EU skatteparadis",
    "high-risk-countries.list.FATF": "FATF",
    "import-customers.wizard.labels.finished": "Importering fullført",
    "import-customers.wizard.labels.first-row-contains-headers": "Første rad inneholder overskrifter",
    "import-customers.wizard.labels.import-companies.button": "Importer selskapskunder",
    "import-customers.wizard.labels.import-people.button": "Importer personkunder",
    "import-customers.wizard.labels.importing": "Importerer {count, number} av {total, number} rader",
    "import-customers.wizard.page.title.companies": "Importer selskap",
    "import-customers.wizard.page.title.people": "Importer person",
    "import-customers.wizard.page.welcome.description": "Velkommen til kundeimportveiviseren",
    "import-customers.wizard.page.welcome.title": "Velkommen til kundeimportveiviseren",
    "import-customers.wizard.status.IMPORTED": "Importering vellykket",
    "import-customers.wizard.status.IMPORTING": "Importerer...",
    "import-customers.wizard.status.IMPORT_ERROR": "Kunne ikke importere",
    "import-customers.wizard.status.INITIAL": "Les fra fil",
    "import-customers.wizard.status.READY_FOR_IMPORT": "Klar for importering",
    "import-customers.wizard.status.VALIDATION_ERROR": "Valideringsfeil",
    "import-customers.wizard.table.hide-column-button.tooltip": "Skjul kolonne",
    "import-customers.wizard.validation-error.duplicate-org-id": "Duplikat orgnr. funnet",
    "import-customers.wizard.validation-error.invalid-org-id": "Ugyldig orgnr.",
    "import-customers.wizard.validation-error.responsible-user-not-found": "Ansvarlig bruker ikke funnet",
    "import-customers.wizard.warning.missing-columns": "{count, plural, one {Denne kolonnen er påkrevd} other {Disse kolonnene er påkrevde}}: {names}",
    "import-customers.wizard.warning.multiple-columns": "{count, plural, one {Denne kolonnen} other {Disse kolonnene}} kan kun velges én gang: {names}",
    "in.progress": "Pågår",
    "industry-info.labels.industry-code": "Næringskode",
    "industry-info.labels.possible-risk": "Mulig risiko",
    "industry-types.filter.label": "Filtrer på bransjer",
    "kar.form.labels.account-number": "Kontonummer",
    "kar.form.labels.check-account-number": "Sjekk kontonummer",
    "kar.form.labels.customer-number": "Personnummer / Org.nr",
    "kar.form.result.by": "Tidspunkt for søk: {timestamp, date, ::yyyyMMdd HH:mm} - Utført av {name}",
    "kar.form.result.failure": "Kontonummer <bold>{accountNumber}</bold> tilhører ikke <bold>{name} ({nationalId})</bold>",
    "kar.form.result.success": "Kontonummer <bold>{accountNumber}</bold> tilhører <bold>{name} ({nationalId})</bold>",
    "kar.form.title": "Verifiser kontoinformasjon",
    "kar.table.status.failure.tooltip": "Ingen kobling mellom kontonummer og personnummer / org. nr.",
    "kar.title": "KAR-register",
    "links.go-back": "Tilbake til {name}",
    "lookup.again": "Søk på nytt",
    "lookup.button.search": "Søk opp selskap",
    "lookup.correct.customer": "Dette er riktig kunde",
    "lookup.error.company.bankrupt": "Selskapet er konkurs",
    "lookup.error.company.closed": "Selskapet er nedlagt/slettet",
    "lookup.error.company.not.found": "Kunne ikke finne selskap med organisasjonsnummer {orgId}",
    "lookup.error.company.under-forced-liquidation": "Selskapet er under tvangsavvikling eller oppløsning",
    "lookup.error.company.under-liquidation": "Selskapet er under avvikling",
    "lookup.error.title": "Kan ikke registrere kunde",
    "lookup.error.wrong.orgid": "Feil orgnr",
    "lookup.input.placeholder": "Orgnr. (9 siffer)",
    "lookup.search.title": "Søk opp selskapet ved bruk av org.nr.",
    "lookup.title": "Bekreft kunde",
    "match-cases-section.count.label": "Antall treff: {count, number} {selected, plural, =0 {} other {(# valgt)}}",
    "match.basic-info.id": "ID:",
    "match.basic-info.last-updated": "Sist oppdatert:",
    "match.basic-info.match-date": "Dato på treff:",
    "match.relations.ACTING": "HANDLER FOR ELLER PÅ VEGNE AV",
    "match.relations.CHILD": "BARN",
    "match.relations.DAUGHTER": "DATTER",
    "match.relations.FATHER": "FAR",
    "match.relations.MOTHER": "MOR",
    "match.relations.PARENT": "FORELDER",
    "match.relations.RELATIVE": "SLEKTNING",
    "match.relations.SIBLING": "SØSKEN",
    "match.relations.SPOUSE": "EKTEFELLE",
    "match.relations.WIFE": "EKTEFELLE",
    "matches.button.confirm.match.description-company": "Treffet gjelder riktig selskap og er relevant",
    "matches.button.confirm.match.description-person": "Treffet gjelder riktig person og er relevant",
    "matches.button.decline.match.description-company": "Treffet gjelder ikke riktig selskap, eller er ikke relevant",
    "matches.button.decline.match.description-person": "Treffet gjelder ikke riktig person, eller er ikke relevant",
    "matches.button.hide.rejected.matches": "Skjul avkreftede treff ({count})",
    "matches.button.review-next-match": "Vurder neste treff",
    "matches.button.show.rejected.matches": "Vis avkreftede treff ({count})",
    "matches.help-text.pep.description": "Vurder om opplysningene i treffet medfører at din kunde/representant er PEP, eller nært familiemedlem eller kjent medarbeider til en PEP.\n\n**Hvilke stillinger/verv omfattes av PEP-definisjonen?**\n\nPolitisk eksponerte personer (PEP) er personer som innehar, eller har innehatt, følgende stillinger og verv iht. [hvitvaskingsloven § 2 bokstav f](https://lovdata.no/lov/2018-06-01-23/§2) (spesifikke _nasjonale_ stillinger er spesifisert nedenfor):\n\n\n\n* Statsoverhode, regjeringssjef, minister eller assisterende minister\n    * _kongen_\n    * _statsministeren_\n    * _statsråd_\n    * _statssekretær_\n* Medlem av nasjonalforsamling\n    * _stortingsrepresentanter_\n    * _faste eller varige vararepresentanter på Stortinget_\n* Medlem av styrende organ i politisk parti\n    * _hovedstyre eller tilsvarende høytstående organ i politiske partier representert på Stortinget (kommunestyre og fylkesting omfattes ikke)_\n* Medlem av høyere rettsinstans som treffer beslutning som ikke eller bare unntaksvis kan ankes\n    * _dommere i Høyesterett, midlertidige og faste stillinger_\n    * _dommere i lagmannsretten (kun ansatte i domstolsapparatet, ikke lekdommere/meddommere), midlertidige og faste stillinger_\n    * _norske dommere ved internasjonale domstoler, f.eks. Den europeiske menneskerettighetsdomstolen (EMD), EFTA-domstolen, FN-domstolen (ICJ)_\n* Medlem av styre i riksrevisjon, revisjonsdomstol eller sentralbank\n    * _medlemmer og varamedlemmer av riksrevisjonskollegium i Riksrevisjonen_\n    * _styret i Norges Bank_\n* Ambassadør eller chargé d’affaires\n    * _norsk ambassadør eller chargé d’affaires ved norsk ambassade (konsul omfattes ikke)_\n* Militær offiser av høyere rang\n    * _forsvarssjefen_\n    * _øverste ledere i de ulike forsvarsgrenene: general, generalløytnant og generalmajor (tilsvarer admiral, viseadmiral og kontreadmiral i sjøforsvaret)_\n* Medlem av administrativt, ledende eller kontrollerende organ i «statlig foretak»*\n    * _styret og administrerende direktør i statlige foretak_\n`*` _«Statlige foretak» er statlige selskaper som ivaretar offentlige oppgaver som hører inn under den offentlige administrasjonen, som f.eks. de regionale helseforetakene (RHF) og Bane NOR. Det avgjørende er om det dreier seg om statlige myndigheter, selv om disse representeres ved et foretak. Statseide selskaper som ikke utfører oppgaver som omfatter offentlig forvaltning, faller utenfor definisjonen._\n_Omfatter ikke datterselskap av slike selskaper, selveiende institusjoner (typisk stiftelser) som helt eller delvis er finansiert av offentlige midler eller lokale foretak (som fylkeskommunale og kommunale foretak)._\n\n* Direktør, styremedlem eller annen person i den øverste ledelsen i en internasjonal organisasjon\n    * _personer som er innstilt, utpekt eller ansatt av regjering, departement eller minister i en internasjonal organisasjon som er opprettet ved inngåelse av en formell internasjonal politisk avtale, f.eks. EFTA, NATO og FN (omfatter ikke ideelle organisasjoner)_\n\n \n\n**Hvem er definert som nært familiemedlem til en PEP?**\n\n\n\n* Foreldre\n* Ektefelle, registrert partner eller samboer\n* Barn, samt barns ektefelle, registrert partner eller samboer\n\nSøsken, stebarn og steforeldre omfattes ikke av definisjonen. Adoptivbarn er likestilte med biologiske barn.\n\n**Hvem er definert som kjent medarbeider til en PEP?**\n\nKjent medarbeider er definert som en person som er kjent for å:\n\n\n\n* Være reell rettighetshaver i felleskap med politisk eksponert person\n* Ha nær forretningsforbindelse til politisk eksponert person\n* Være eneste reelle rettighetshaver i selskap som i realiteten er etablert for å begunstige politisk eksponert person\n\n_Se mer informasjon i [veilederen til hvitvaskingsloven](https://www.finanstilsynet.no/nyhetsarkiv/rundskriv/2022/veileder-til-hvitvaskingsloven/)_",
    "matches.help-text.pep.title": "Hvordan vurdere PEP-treff?",
    "matches.labels.details": "Hva gjelder treffet?",
    "matches.labels.negative-news": "Negative nyheter",
    "matches.labels.negative-news.helper-text-company": "Selskapet er knyttet til negative nyheter som kan indikere høyere risiko",
    "matches.labels.negative-news.helper-text-person": "Vedkommende er knyttet til negative nyheter som kan indikere høyere risiko",
    "matches.labels.other": "Annet",
    "matches.labels.other.helper-text-company": "Selskapet er knyttet til andre typer hendelser (beskriv i fritekstfeltet)",
    "matches.labels.other.helper-text-person": "Vedkommende er knyttet til andre typer hendelser (beskriv i fritekstfeltet)",
    "matches.labels.pep": "PEP",
    "matches.labels.pep.detailed": "PEP (Politically Exposed Person)",
    "matches.labels.pep.detailed.tooltip": "Politisk eksponerte personer (PEP) er personer som innehar et særskilt offentlig tillitsverv og derfor kan være eksponert for bestikkelser og annen korrupsjon",
    "matches.labels.pep.helper-text": "Vedkommende er en politisk eksponert person, eller nært knyttet til en (iht. til definisjonen i hvitvaskingsloven)",
    "matches.labels.rejected-by": "Avkreftet av {name}, {timestamp, date, ::yyyyMMdd}",
    "matches.labels.relations": "Relasjoner / tilknytninger",
    "matches.labels.review.description": "Begrunnelse",
    "matches.labels.review.description.placeholder": "Begrunn vurderingen",
    "matches.labels.sanction": "Sanksjon",
    "matches.labels.sanction.helper-text-company": "Selskapet er sanksjonert og oppført i sanksjonslisten",
    "matches.labels.sanction.helper-text-person": "Vedkommende er sanksjonert og oppført i sanksjonslisten",
    "matches.labels.sanctions": "Sanksjoner",
    "matches.labels.source": "Kilde: ",
    "matches.labels.source.name": "Kildenavn:",
    "matches.labels.source.publication-source": "Publikasjonskilde:",
    "matches.labels.source.publisher": "Utgiver:",
    "matches.labels.source.url": "Kilde:",
    "matches.navigation.tooltip": "{summary} på {name}",
    "matches.review.approved": "Treff bekreftet",
    "matches.review.denied": "Treff avkreftet",
    "matches.text.no.confirmed.matches": "Ingen bekreftede treff",
    "matches.text.no.matches": "Ingen treff funnet 🎉",
    "matches.title.compare.companies": "Sammenligning av selskapsinfo",
    "matches.title.compare.persons": "Sammenligning av personalia",
    "matches.title.details.matches": "Treff på screening",
    "matches.titles.assessment": "Vurdering av treff",
    "matches.titles.categories": "KATEGORIER",
    "matches.titles.comments": "BEMERKNINGER",
    "matches.titles.company-customer": "Din Kunde/Representant",
    "matches.titles.data-source": "Treff mot datakilde",
    "matches.titles.events": "HENDELSER",
    "matches.titles.geographic-affiliation": "Geografisk tilknytning",
    "matches.titles.key-information": "Nøkkelinformasjon",
    "matches.titles.listings": "OPPFØRINGER",
    "matches.titles.matches-against-data-source": "TREFF MOT DATAKILDE",
    "matches.titles.person-customer": "Personalia",
    "matches.titles.positions": "STILLINGER",
    "matches.titles.relations": "RELASJONER",
    "matches.titles.relevant-links": "RELEVANTE LENKER",
    "matches.titles.sources": "KILDER",
    "matches.titles.summary": "OPPSUMMERING",
    "measures-settings.page.description": "Her kan du opprette tiltak du kan benytte i risikovurderingen av dine kunder.",
    "measures-settings.page.filter.hide-archived-measures": "Skjul arkiverte tiltak",
    "measures-settings.page.filter.show-archived-measures": "Vis arkiverte tiltak",
    "measures-settings.page.title": "Tiltak",
    "measures.confirm-archive.description": "Er du sikker på at du vil arkivere tiltaket «{name}»?.\nDette vil ikke fjerne eksisterende tiltak.",
    "measures.confirm-archive.labels.archive.button": "Arkiver tiltak",
    "measures.confirm-archive.title": "Arkiver tiltak",
    "measures.confirm-remove.description": "Er du sikker på at du vil slette tiltaket «{name}»?",
    "measures.confirm-remove.title": "Slett tiltak",
    "measures.errors.empty-measure": "Tomt tiltak",
    "measures.list.loading.error-action": "Få liste over tiltak",
    "measures.list.loading.label": "Laster tiltak",
    "measures.modal.empty-state": "Det er foreløpig ingen tiltak",
    "measures.modal.errors.description-validation-error": "Beskrivelse er påkrevd",
    "measures.modal.errors.title-not-unique-validation-error": "Tittel eksisterer allerede",
    "measures.modal.errors.title-validation-error": "Tittel er påkrevd",
    "measures.modal.title.add": "Opprett tiltak",
    "measures.modal.title.update": "Endre tiltak",
    "measures.modal.title.view": "Se tiltak",
    "measures.popover.labels.button": "Legg til tiltak",
    "measures.popover.labels.filter": "Opprett nytt tiltak",
    "measures.popover.labels.global-list.empty": "Det finnes ingen eksisterende tiltak",
    "measures.popover.labels.global-list.title": "Velg eksisterende tiltak",
    "measures.popover.labels.new-empty-measure": "Opprett nytt tiltak",
    "menu.import.companies": "Importer selskaper",
    "menu.language.english": "Språk: Engelsk",
    "menu.language.norwegian": "Språk: Norsk",
    "menu.logout": "Logg ut",
    "menu.plan-upgrade": "AML-pakke: {packageName}",
    "menu.settings": "Innstillinger",
    "menu.support-email": "Kontakt support",
    "menu.whats-new": "Hva er nytt?",
    "missing-required-permission.banner.description": "Kun {roles} kan endre disse innstillingene",
    "modals.company.edit.title": "Endre selskapsdetaljer",
    "modals.copy.link.button": "Kopier link",
    "modals.copy.link.button.copied": "Kopiert",
    "modals.delete.signature.button": "Slett KYC-forespørsel",
    "modals.delete.signature.description": "Er du sikker på at du ønsker å slette KYC-forespørselen til {name}?",
    "modals.delete.signature.title": "Slett KYC-forespørsel",
    "modals.headings.address": "Adresse",
    "modals.headings.personal-information": "Personopplysninger",
    "modals.owner.confirm.archive.description": "Er du sikker på at du vil arkivere rettighetshaveren {owner}?",
    "modals.owner.confirm.archive.title": "Arkiver rettighetshaver",
    "modals.owner.headings.ownership-in-company": "Eierandel i selskapet",
    "modals.owner.labels.percent_share": "Eierandel i %",
    "modals.owner.messages.owner-restored": "Rettighetshaveren «{name}» ble gjenopprettet",
    "modals.owner.title.add": "Legg til rettighetshaver",
    "modals.owner.title.update": "Endre rettighetshaver",
    "modals.owner.tooltips.archive-disabled": "Du kan ikke arkive en rettighetshaver som screenes",
    "modals.person.edit.title": "Endre persondetaljer",
    "modals.remind.signer.button": "Send påminnelse",
    "modals.remind.signer.title": "Send påminnelse til mottaker",
    "modals.role.confirm.delete.description": "Er du sikker på at du vil slette {role} fra listen over rolleinnehavere?\nHandlingen kan ikke angres.",
    "modals.role.confirm.delete.title": "Slett rolleinnehaver",
    "modals.role.headings.role-in-company": "Rolle i selskapet",
    "modals.role.labels.role_type": "Rolle",
    "modals.role.labels.select.placeholder": "Velg rolle",
    "modals.role.title.add": "Legg til rolleinnehaver",
    "modals.role.title.update": "Endre rolleinnehaver",
    "modals.role.tooltips.delete-disabled": "Du kan ikke slette en rolle som screenes",
    "modals.update.signature.button": "Lagre endringer",
    "modals.update.signature.customer": "KUNDE",
    "modals.update.signature.error.duplicate-email": "Denne e-posten er allerede brukt for en annen mottaker",
    "modals.update.signature.title": "Rediger mottakerinfo",
    "nav-bar.dashboard": "Dashboard",
    "nav-bar.new-customer": "Registrer kunde",
    "nav-bar.new-customer.company": "Selskapskunde",
    "nav-bar.new-customer.person": "Personkunde",
    "nav-bar.overview": "Kunder",
    "navigation.page.customers.title": "Kunder",
    "navigation.settings.checklists.label": "Sjekklister",
    "navigation.settings.internal-tools.kyc-previewer.label": "KYC Previewer",
    "navigation.settings.internal-tools.section.title": "Internal Tools",
    "navigation.settings.kyc.auto-reminder.label": "KYC-påminnelse til kunde",
    "navigation.settings.kyc.custom-questionnaires.label": "Egne KYC-spørsmål",
    "navigation.settings.notifications.customer-info.label": "Selskapsoppdateringer",
    "navigation.settings.notifications.section.title": "Varslinger",
    "navigation.settings.onboarding.person.title": "Personkunder",
    "navigation.settings.onboarding.section.title": "Kunderegistrering",
    "navigation.settings.risk-management.section.title": "Risikohåndtering",
    "navigation.settings.users.section.title": "Brukeradministrasjon",
    "navigation.settings.users.title": "Alle brukere",
    "new-company-customer.country-options.no": "Norsk selskap",
    "new-company-customer.country-options.other": "Utenlandsk selskap",
    "new-company-customer.texts.manual": "Fyll inn selskapets informasjon manuelt",
    "new-company-customer.titles.manual": "Registrer utenlandsk selskap",
    "new-company-customer.titles.norwegian": "Registrer norsk selskap",
    "not-found.description": "Siden er kanskje flyttet, slettet, eller kanskje det er feil i url’n",
    "not-found.title": "Hmm, her var det jo ingenting?",
    "not.specified": "Ikke oppført",
    "notifications-settings.followup.form.label": "Hvor ofte vil du motta varsling på e-post?",
    "notifications-settings.followup.form.label.monthly": "Én gang i måneden",
    "notifications-settings.followup.form.label.no-notification": "Ingen varsling",
    "notifications-settings.followup.form.label.weekly": "Én gang i uken",
    "onboarding-settings.page.description": "Her kan du velge hvilke innstillinger som skal gjelde for registrering av alle nye kunder. Valgene dine blir da forhåndsutfylt ved nye kunderegistreringer.",
    "onboarding-settings.page.title": "Registrering av personkunder",
    "onboarding-summary.signature-table-column.content-language": "INNHOLDSSPRÅK",
    "onboarding-summary.signature-table-column.email-or-url": "E-POST/LINK",
    "onboarding-summary.signature-table-column.name": "NAVN",
    "onboarding-summary.signature-table-column.scope": "OMFANG",
    "onboarding-summary.title": "Oppsummering",
    "onboarding.assignments-and-attachments.description": "Opprett et oppdrag på kunden og last opp nødvendige dokumenter tilhørende oppdraget eller kundeforholdet.",
    "onboarding.assignments-and-attachments.title": "Oppdrag og dokumenter",
    "onboarding.assignments.description": "Opprett et oppdrag på kunden",
    "onboarding.assignments.title": "Oppdrag",
    "onboarding.associated-project.title": "Tilhørende prosjekt",
    "onboarding.bar.company.assignments-and-attachments.title": "Oppdrag og dokumenter",
    "onboarding.bar.company.assignments.title": "Oppdrag",
    "onboarding.bar.company.disclosures.title": "KYC",
    "onboarding.bar.company.screening.title": "Screening",
    "onboarding.bar.company.summary.title": "Oppsummering",
    "onboarding.bar.manual-company.information.title": "Opplysninger",
    "onboarding.cancel.and.delete": "Avbryt registrering",
    "onboarding.cancel.and.save": "Lagre og fortsett senere",
    "onboarding.cancel.confirm.description": "Er du sikker på at du ønsker å avbryte registreringen av {name}?\nDersom du avbryter registreringen vil {name} bli slettet, og du må eventuelt starte registreringen på nytt.",
    "onboarding.cancel.confirm.title": "Avbryt registrering",
    "onboarding.cancel.onboarding": "Lukk",
    "onboarding.disclosures.company-description": "I henhold til hvitvaskingsloven må det gjennomføres en kundekontroll på den/de som skal handle på vegne av kunden. Velg hvem dette gjelder.",
    "onboarding.disclosures.duplicate.emails.error": "Det er tastet inn samme e-postadresse til flere personer. Se over e-postadressene.",
    "onboarding.disclosures.person-description": "I henhold til hvitvaskingsloven må det gjennomføres en kundekontroll på kunden.",
    "onboarding.disclosures.person.require-disclosure": "Legitimer og/eller send KYC-spørsmål",
    "onboarding.disclosures.send-email.text": "Det blir opprettet en unik link til legitimering og KYC-spørsmål som er tilgjengelig fra kundesiden. Du er selv ansvarlig for å sende denne til vedkommende.",
    "onboarding.disclosures.title": "Legitimering og KYC-spørsmål",
    "onboarding.new.person.title": "Registrer personkunde",
    "onboarding.screening-type.monitoring.helper.text": "Det informeres fortløpende dersom det oppstår nye treff mot PEP, sanksjon eller negative nyheter.",
    "onboarding.screening-type.one-time.helper.text": "Kontrollerer kunden én gang mot PEP- og sanksjonslister, samt negative nyheter, før kundeforholdet er oppe til vurdering.",
    "onboarding.status.draft-review": "Vurderingsutkast",
    "onboarding.status.ready-for-review": "Klar for vurdering",
    "onboarding.status.started": "Påbegynt",
    "outstanding-shares.banner.description": "Aksjonærregisteret mangler opplysninger om <bold>{outstandingShares, number}</bold> aksjer av <bold>{totalShares, number}</bold>.\nDet anbefales derfor å kontakte kunden for å få fremlagt en fullstending aksjeeierbok.\nDeretter kan opplysningene om eiere og reell(e) rettinghetshaver(e) oppdateres manuelt under.",
    "outstanding-shares.banner.title": "Utestående aksjer",
    "owners.card.buttons.add-owner": "Legg til rettighetshaver",
    "owners.card.cannot-have-shareholders": "Denne selskapsformen ({companyType}) kan ikke ha aksjonærer, så vi identifiserer ikke rettighetshavere med aksjeeierandel for dette selskapet.",
    "owners.card.manual.no-owners": "Ingen rettighetshavere.",
    "owners.card.newly-founded.no-owners": "Dette selskapet er etablert etter at Aksjonærregisteret ble oppdatert (31. desember).\nUndersøk om kunden har oppgitt riktig/oppdatert informasjon i KYC-skjemaet etter at KYC skjemaet er besvart.",
    "owners.card.no-owners": "Det er ingen rettighetshavere som eier/kontroller (direkte eller indirekte) 5 prosent eller mer (kilde: Aksjonærregisteret)",
    "ownership-update.actions.labels.confirm-all-updates": "Bekreft alle oppdateringer",
    "ownership-update.actions.labels.ignore": "Ignorer",
    "ownership-update.banner.description": "Vi har fått viktige oppdateringer som påvirker eierforholdene hos denne kunden.\nInformasjonen er hentet fra Aksjonærregisteret {year}, og reflekterer dermed eierforholdene slik de fremstod 31.12.{year}. Du må bekrefte eller ignorere de oppførte endringene.",
    "ownership-update.banner.finished.description": "Det er ingen flere eierskapsoppdateringer på denne kunden. 🎉",
    "ownership-update.confirm-all.modal.action.label": "Gå til screening-innstillinger",
    "ownership-update.confirm-all.modal.content": "Dette påvirker ikke screeningen. Du må endre dette manuelt ved behov, f.eks. hvis nye rettighetshavere skal screenes, eller utgående rettighetshavere skal fjernes fra screeningen.",
    "ownership-update.confirm-all.modal.title": "Flott! Da var det gjort! 🎉",
    "ownership-update.description.update": "Sist oppdatert fra Aksjonærregisteret {year}",
    "ownership-update.info.label": "Oppdatering på eierforhold",
    "ownership-update.reject.confirmation.modal.action.label": "Ignorer endring",
    "ownership-update.reject.confirmation.modal.content.add": "Ved å ignorere endringen slettes <bold>{name}</bold> fra listen over rettighetshavere.",
    "ownership-update.reject.confirmation.modal.content.delete": "Ved å ignorere endringen beholdes <bold>{name}</bold> i listen over rettighetshavere.",
    "ownership-update.reject.confirmation.modal.content.update": "Ved å ignorere endringen settes eierandelen til <bold>{name}</bold> tilbake til {value}.",
    "ownership-update.reject.confirmation.modal.title": "Er du sikker på at du vil ignorere endringen?",
    "ownership.view.table": "Rettighetshavere",
    "ownership.view.tree": "Eierskapsstruktur",
    "ownership.view.tree.info": "Informasjonen er tatt direkte fra Aksjonærregisteret. Vi inkluderer alle personer med minst 5% eierandel, eller som ved indirekte eierskap eier minst 25% i hvert ledd.",
    "pending-tasks.labels.awaiting-disclosures": "Venter besvarelse av {count, plural, =1 {1 KYC-forespørsel} other {# KYC-forespørsler}}",
    "pending-tasks.labels.awaiting-documents": "Venter ferdigstilling av {count, plural, =1 {1 e-signaturforespørsel} other {# e-signaturforespørsler}}",
    "pending-tasks.labels.open-matches": "Venter vurdering av {count, number} treff",
    "pending.tasks.labels.approve-review": "Se vurdering",
    "pending.tasks.labels.days-since-onboarding": "{days, plural, =0 {forespørsel sendt i dag} =1 {1 dag siden forespørselen} other {# dager siden forespørselen}}",
    "pending.tasks.labels.finish-onboarding": "Fortsett registrering",
    "pending.tasks.labels.followup-customer": "Venter oppfølging",
    "pending.tasks.labels.open-draft-review": "Åpne vurderingsutkast",
    "pending.tasks.labels.remind-recipients": "Påminn mottakere",
    "pending.tasks.labels.review-customer": "Vurder kunde",
    "pending.tasks.labels.review-matches": "Vurder {count, plural, =1 {treffet} other {treff}}",
    "pending.tasks.labels.review-measures": "Utfør tiltak",
    "pending.tasks.labels.review-ownership-updates": "Vurder oppdatering på eierforhold",
    "pending.tasks.labels.see-draft-reviews": "Se vurderingsutkast",
    "pending.tasks.labels.see-pending-disclosures": "Se {count, plural, =1 {forespørsel} other {forespørsler}}",
    "pending.tasks.labels.see-pending-documents": "Se {count, plural, =1 {dokument} other {dokumenter}}",
    "pending.tasks.status.approve-review": "Godkjenn/avslå vurdering",
    "pending.tasks.status.followup": "Oppfølging: {days, plural, =-1 {utgått} =0 {i dag} =1 {1 day} other {om # dager}}",
    "pending.tasks.status.review-measures": "{count, number} ventende tiltak",
    "pending.tasks.status.waiting-for-approval": "Venter bekreftelse på vurdering",
    "pending.tasks.status.waiting-for-approval.subtitle": "Forespurt på {timestamp, date, ::yyyyMMdd} av {names}",
    "person-name.description.manually-created": "Lagt til av {name}, {timestamp, date, ::yyyyMMdd}",
    "person.customer.details.personal.number": "Personnummer",
    "person.details.caption.address": "ADRESSE",
    "person.details.caption.birth.date": "FØDSELSDATO",
    "person.details.caption.citizenship": "STATSBORGERSKAP",
    "person.details.caption.externalId": "ID",
    "person.details.caption.first.name": "FORNAVN",
    "person.details.caption.last.name": "ETTERNAVN",
    "person.details.caption.origin": "FØDELAND",
    "person.details.caption.person.number": "PERSONNUMMER",
    "person.details.caption.residence": "BOSTEDS/OPPHOLDSLAND",
    "person.details.title": "kundedetaljer",
    "personal.number.placeholder.no": "ddmmååXXXXX",
    "plan-conversion.add-to-projects.description": "Oppgrader AML-pakken din for å aktivere prosjekter.",
    "plan-conversion.attachments.description": "Oppgrader din AML-pakke for å få tilgang til dokumentopplastning og e-signering.",
    "plan-conversion.banner.labels.link": "Se de ulike AML-pakkene",
    "plan-conversion.customer-action.label": "Oppgrader din AML-pakke for denne funksjonen",
    "plan-conversion.messages.access-feature": "Oppgrader din AML-pakke for å få tilgang til denne funksjonen.",
    "plan-conversion.modal.title": "Oppgrader din AML-pakke",
    "plan-conversion.projects.description": "Prosjekter er en funksjon som gjør det mulig å samle flere kunder i samme oversikt, som gjør det enklere å ha full kontroll over ulike kunder tilhørende ett og samme prosjekt.",
    "plan-conversion.projects.image.alt-text": "Prosjektdetaljer bilde",
    "project.actions.labels.edit": "Rediger prosjektdetaljer",
    "project.actions.labels.end-project": "Avslutt prosjekt",
    "project.actions.labels.reactivate": "Reaktiver prosjekt",
    "project.banner.vitec.imported.text": "Start med å registrere kunden. Kunderapporten lastes automatisk opp til Vitec når du er ferdig med vurdering av kunden.",
    "project.banner.vitec.label": "Dette prosjektet er importert fra Vitec",
    "project.button.imported-from-vitec": "Vitec",
    "project.customers.actions.remove-from-project": "Fjern fra prosjekt",
    "project.customers.buttons.add-customers": "Legg til kunder",
    "project.customers.buttons.add-existing-customers": "Eksisterende kunder",
    "project.customers.buttons.add-new-company-customer": "Registrer ny selskapskunde",
    "project.customers.buttons.add-new-person-customer": "Registrer ny personkunde",
    "project.customers.empty.header": "Det er ikke oppført noen kunder i dette prosjektet.",
    "project.customers.empty.message": "Legg til kunder i prosjektet ved å trykke på knappen «Legg til kunder» ovenfor.",
    "project.customers.modal.title": "Legg til kunder i prosjekt «{name}»",
    "project.customers.title": "Kunder i prosjekt",
    "project.details.labels.description": "Legg til prosjektbeskrivelse",
    "project.details.labels.name": "Angi navn på prosjekt",
    "project.end.confirmation.action.label": "Avslutt prosjekt «{name}»",
    "project.end.confirmation.description": "Er du sikker på at du vil avslutte prosjektet «{name}» ?",
    "project.end.confirmation.title": "Avslutt prosjekt",
    "project.info.labels.created": "Opprettet",
    "project.info.labels.description": "Beskrivelse",
    "project.info.labels.project-managers": "Prosjektansvarlig",
    "project.info.labels.status": "Status",
    "project.info.manager.empty.user": "Velg prosjektansvarlig",
    "project.info.manager.error": "Noe gikk galt ved lagring av prosjektansvarlig",
    "project.notes.placeholder": "Legg igjen notater om prosjektet",
    "project.remove-customers.confirmation.action.label": "Fjern kunder",
    "project.remove-customers.confirmation.description": "Er du sikker på at du vil fjerne {names} fra prosjektet «{projectName}» ?",
    "project.remove-customers.confirmation.title": "Fjern kunder",
    "project.remove-customers.success.message": "Fjernet {count, plural, =1 {kunden} other {# kunder}}",
    "project.status.ACTIVE": "Aktiv",
    "project.status.INACTIVE": "Inaktiv",
    "project.vitec.customers.empty.message": "Legg til kunder i prosjektet ved å trykke på knappen Vitec ovenfor.",
    "projects.common.labels.create.project": "Opprett prosjekt",
    "projects.common.labels.update.project": "Oppdater prosjektet",
    "projects.list.column.name": "PROSJEKTNAVN",
    "projects.list.column.status": "STATUS",
    "projects.list.empty.projects.header": "Du har ikke opprettet noen prosjekter enda.",
    "projects.list.empty.projects.message": "Opprett ditt første prosjekt ved å trykke på knappen øverst i høyre hjørne.",
    "projects.list.filters.search.hint": "Søk på prosjekter",
    "projects.modal.empty.search.description": "Sjekk om du har skrevet riktig, eventuelt legg til kunden direkte fra prosjektet",
    "projects.modal.empty.search.title": "Dette prosjektet kunne vi dessverre ikke finne",
    "projects.modal.filters.search.hint": "Søk på prosjekt",
    "projects.modal.success.message": "{count, plural, =1 {1 kunde} other {# kunder}} lagt til prosjekt",
    "projects.modal.title": "Legg til i prosjekt",
    "projects.page.header.projects.count": "Antall prosjekter: {count} {selected, plural, =0 {} other {, # valgt}}",
    "projects.page.title": "Prosjekter",
    "question.editor.buttons.delete.label": "Slett spørsmål",
    "question.editor.errors.duplicate-question": "Samme spørsmål finnes allerede",
    "question.editor.errors.empty-question": "Skriv inn spørsmål",
    "question.editor.questions-table.empty.label": "Du har foreløpig ikke lagt til noen spørsmål i denne listen",
    "questionnaire.archive.confirmation.description": "Er du sikker på at du vil arkivere spørreskjemaet \"{name}\"?",
    "questionnaire.archive.confirmation.title": "Arkiver spørreskjemaet",
    "questionnaire.choices-table.button.add.label": "Legg til svaralternativ",
    "questionnaire.choices-table.description.label": "Svaralternativ {index}",
    "questionnaire.choices-table.errors.empty-option": "Tomt svaralternativ",
    "questionnaire.details.page.invalid": "Ugyldig spørreskjema",
    "questionnaire.details.page.title.new-questionnaire": "Egne KYC-spørsmål",
    "questionnaire.page.add-questionnaire.button.label": "Opprett egne KYC-spørsmål",
    "questionnaire.page.filter.hide-archived-questionnaires": "Skjul arkiverte spørreskjemaer",
    "questionnaire.page.filter.placeholder": "Filtrér egendefinerte spørreskjemaer etter navn",
    "questionnaire.page.filter.show-archived-questionnaires": "Vis arkiverte spørreskjemaer",
    "questionnaire.page.header.description": "Her kan du opprette egne KYC-spørsmål som kan sendes dine kunder, enten som en del av våre bransjetilpassede KYC-skjemaer, eller frittstående.",
    "questionnaire.page.title": "Egne KYC-spørsmål",
    "questionnaire.preview.modal.title": "Forhåndsvis spørreskjema \"{name}\"",
    "questionnaire.question.description.label": "Spørsmål på {language}",
    "questionnaire.question.type.boolean": "Ja/Nei",
    "questionnaire.question.type.multiple-choice": "Flervalg",
    "questionnaire.question.type.multiple-country-choice": "Flervalg med land",
    "questionnaire.question.type.single-choice": "Rullegardinmeny",
    "questionnaire.question.type.single-country-choice": "Rullegardinmeny med land",
    "questionnaire.question.type.text": "Tekstfelt",
    "questionnaire.title.label": "Tittel på {language}",
    "questions.editor.buttons.add-question.label": "Legg til spørsmål",
    "responsible-users.label": "Ansvarlige brukere",
    "responsible.empty.users": "Velg ansvarlige brukere",
    "responsible.error": "Noe gikk galt ved lagring av ansvarlig",
    "responsible.label": "Ansvarlig",
    "responsible.modal.message": "Angi ansvarlig brukere for {names}",
    "responsible.modal.title": "Angi ansvarlig brukere",
    "review.checklist.answer.error.empty-additional-info": "Du må legge inn en beskrivelse i tekstfeltet over",
    "review.checklist.answer.placeholder": "Utdyp her:",
    "review.checklist.details.page.messages.created-successfully": "Sjekklisten «{name}» ble opprettet",
    "review.checklist.details.page.title.edit-checklist": "Endre sjekkliste",
    "review.checklist.details.page.title.new-checklist": "Opprett sjekkliste",
    "review.checklist.duplicate.modal.success.message": "Sjekklisten er kopiert og lagret som «{name}»",
    "review.checklist.duplicate.modal.title": "Lag kopi av sjekklisten «{name}»",
    "review.checklist.editor.condition-type.purpose": "Oppdragstype",
    "review.checklist.editor.condition-type.risk": "Risikokategori",
    "review.checklist.editor.condition-type.tags": "Tags",
    "review.checklist.editor.empty.name": "Du må gi sjekklisten et navn",
    "review.checklist.editor.labels.customer-type": "Sjekklisten skal gjelde for:",
    "review.checklist.editor.labels.required": "Skal sjekklisten være obligatorisk?",
    "review.checklist.editor.labels.risk-type": "Hvilke betingelser skal trigge at sjekklisten legges til?",
    "review.checklist.editor.labels.selection-type": "Skal sjekklisten legges automatisk til i risikovurderingen?",
    "review.checklist.editor.labels.yes-always": "Ja, alltid",
    "review.checklist.editor.labels.yes-choose": "Ja, velg betingelser",
    "review.checklist.editor.selection-type.always": "Alltid",
    "review.checklist.editor.selection-type.automatic": "Automatisk",
    "review.checklist.editor.selection-type.manual": "Manuelt",
    "review.checklist.editor.tips.banner.description": "1. Gi sjekklisten navn og beskrivelse, samt hvilken kundetype denne skal gjelde for.\n2. Velg om den skal legges til automatisk i risikovurderingen, eller velg hva som skal trigge sjekklisten. \n3. Velg om sjekklisten skal være obigatorisk for alle brukere.\n4. Legg til spørsmål og formuler disse som \"Ja\"/\"Nei\"-spørsmål\n5. Ved \"Ja\" er det påkrevd for saksbehandler å utdype ytterligere\n6. Klikker du på knappen \"Forhåndsvis\" vises sjekklisten slik den vil fremstå i selve risikovurderingen",
    "review.checklist.editor.tips.banner.title": "Opprettelse av sjekklister",
    "review.checklist.preview.modal.title": "Forhåndsvis sjekkliste «{name}»",
    "review.checklist.template.instance.modal.title": "Opprett sjekkliste fra mal: {name}",
    "review.checklist.template.preview.modal.title": "Forhåndsvis mal: {name}",
    "review.checklists.archive.confirmation.description": "Er du sikker på at du vil arkivere sjekklisten «{name}»?",
    "review.checklists.archive.confirmation.title": "Arkiver sjekklisten",
    "review.checklists.page.add.button.label": "Opprett sjekkliste",
    "review.checklists.page.filter.hide-archived-checklists": "Skjul arkiverte sjekklister",
    "review.checklists.page.filter.placeholder": "Filtrér sjekklister etter navn",
    "review.checklists.page.filter.show-archived-checklists": "Vis arkiverte sjekklister",
    "review.checklists.page.header.description": "Her kan du opprette egne sjekklister som kan benyttes i risikovurderingen av dine kunder.\nDu kan opprette nye sjekklister, eller ta utgangspunkt i en mal og tilpasse denne til din virksomhet.",
    "review.checklists.page.table.header": "Mine sjekklister",
    "review.checklists.page.title": "Sjekklister",
    "review.status.APPROVED": "Godkjent",
    "review.status.NOT_READY": "Ikke klar - screening pågår",
    "review.status.REJECTED": "Avslått",
    "review.status.REVIEW_REQUIRED": "Klar for vurdering",
    "reviews.header.banner.pending-disclosures.button.label": "Se gjenstående KYC- og legitimasjonsforespørsler",
    "reviews.header.banner.pending-disclosures.description": "Det er {count, plural, =1 {1 ubesvart KYC- og legitimasjonsforespørsel} other {# ubesvarte KYC- og legitimasjonsforespørsler}}. Disse kan gi informasjon som påvirker hvordan du ønsker å risikovurdere kunden din",
    "reviews.header.banner.unreviewed-match-cases.button.label": "Se gjenstående treff",
    "reviews.header.banner.unreviewed-match-cases.description": "Det er {count, number} mulige treff som bør vurderes før du vurderer din kunde.",
    "reviews.header.title": "Risikovurdering",
    "reviews.labels.ask-for-confirmation": "Be om bekreftelse på vurdering",
    "reviews.labels.change-review": "Ny vurdering",
    "reviews.labels.customer-risk": "Kunden tilhører en risikobransje",
    "reviews.labels.mark-as": "Marker kunde som",
    "reviews.labels.mark-as.pep": "PEP",
    "reviews.labels.mark-as.sanction": "Sanksjon",
    "reviews.labels.new-review": "Ny vurdering",
    "reviews.labels.no-reviews": "Det finnes ingen vurderinger på kunden eller tilknyttede oppdrag",
    "reviews.labels.perform-a-review": "Utfør vurdering",
    "reviews.labels.relationship.change": "Angi risiko",
    "reviews.labels.review-header": "Vurdering",
    "reviews.labels.review-label": "Begrunnelse",
    "reviews.labels.review.assessment": "Godkjenn/avslå vurdering",
    "reviews.labels.risk-indicators": "Risikoindikatorer{count, plural, =0 {} other {: #}}",
    "reviews.labels.risk-tags": "Organiser med tags",
    "reviews.labels.select-user-for-confirmation": "Velg hvem som skal bekrefte vurderingen",
    "reviews.labels.toggle.hide-previous": "Skjul tidligere vurderinger ({count, number})",
    "reviews.labels.toggle.show-previous": "Vis tidligere vurderinger ({count, number})",
    "reviews.labels.unmark-as": "Fjernet merking som {badges}",
    "reviews.placeholders.review-rational": "Begrunn vurderingen som er foretatt",
    "reviews.titles.checklist": "Sjekkliste for kundevurdering",
    "reviews.titles.existing-reviews": "Eksisterende vurderinger",
    "reviews.titles.guideline-tips": "Tips til hva en god vurdering bør inneholde",
    "reviews.titles.review-customer": "Risikovurdering av kunde",
    "reviews.titles.risk-review": "Risikovurdering",
    "risk-indicators.geographic-risk.description": "Rapporteringspliktige etter hvitvaskingsregelverket skal gjennomføre forsterkede kundetiltak med hensyn til kundeforhold og transaksjoner som involverer høyrisikoland, jf. hvitvaskingsforskriften § 4-10.",
    "risk-indicators.geographic-risk.title": "{country} funnet i følgende liste(r) over høyrisikoland: {listNames}",
    "risk-indicators.labels.confirmed-matches": "BEKREFTEDE TREFF: {count, number}",
    "risk-indicators.labels.disclosure-risk": "KYC-BESVARELSER{count, plural, =0 {} other {: #}}",
    "risk-indicators.labels.geographic-risk": "GEOGRAFISK RISIKO{count, plural, =0 {} other {: #}}",
    "risk-indicators.labels.industry-risk": "BRANSJERISIKO{count, plural, =0 {} other {: #}}",
    "risk-indicators.labels.personnel-risk": "ROLLEINNEHAVER OG RETTIGHETSHAVERE{count, plural, =0 {} other {: #}}",
    "risklabel.HIGH": "Høy",
    "risklabel.LOW": "Lav",
    "risklabel.MEDIUM": "Medium",
    "risklabel.NOT_SET": "Uvurdert",
    "risklabel.null": "Ikke vurdert",
    "roles.button.labels.hide-expired-roles": "Skjul utgåtte rolleinnehavere",
    "roles.button.labels.show-expired-roles": "Vis utgåtte rolleinnehavere ({count, number})",
    "roles.messages.no-roles": "Ingen roller",
    "screening-type.MONITORING": "Løpende",
    "screening-type.NONE": "-",
    "screening-type.NOT_SET": "-",
    "screening-type.ONE_TIME": "Kun enkeltstående",
    "screening-type.label.monitoring": "Løpende",
    "screening-type.label.one-time": "Kun enkeltstående",
    "screening-type.modal.message": "Angi screening-innstillinger for {names}",
    "screening-type.modal.title": "Velg screening",
    "screening-type.tooltip.person.screening.monitoring": "Personen er satt i løpende screening",
    "screening-type.tooltip.person.screening.none": "Personen er ikke satt i løpende screening",
    "screening.buttons.add-role": "Legg til rolleinnehaver",
    "screening.errors.content": "Prøv igjen litt senere",
    "screening.errors.description": "Gi det noen sekunder og prøv igjen. Eventuelt hent deg en kaffe :)",
    "screening.errors.heading": "Beklager, dette tar altfor lang tid ...",
    "screening.infobox.owners.definition": "En (reell) rettighetshaver er en person som, alene eller sammen med andre, kan utøve (reell) kontroll over selskapet. Det er flere eksempler på dette:\n\n• En person som alene innehar mer enn 25 % av aksjene/stemmene\n\n• Familiemedlemmer som til sammen (direkte eller indirekte) innehar mer enn 25% av aksjene/stemmene\n\n• En person, som via spesielle vedtekter, aksjonæravtale(r) eller annen avtale kontrollerer selskapet.\n\nDu kan lese mer om identifisering av reelle rettighetshavere i Hvitvaskingsloven: https://lovdata.no/lov/2018-06-01-23/§14",
    "screening.infobox.owners.text.manual": "Rettighetshavere må manuelt legges til ved registrering av utenlandske selskaper.",
    "screening.infobox.owners.text.norwegian": "For selskap som kan ha aksjonærer (f.eks. aksjeselskap), identifiserer vi fysiske personer som eier 5 prosent eller mer gjennom hele eierstrukturen (kilde: Aksjonærregisteret). Du er selv ansvarlig for å kontrollere disse, og eventuelt oppdatere og/eller legge til manglende rettighetshavere.",
    "screening.infobox.owners.title": "Hva er en rettighetshaver?",
    "screening.infobox.roles.definition": "En rolleinnehaver er en person som har en rolle i selskapet. Eksempler på dette er styremedlemmer, daglig leder/administrerende direktør, og personer som kan signere på vegne av selskapet (har signatur/prokurarett).",
    "screening.infobox.roles.text.manual": "Rolleinnehavere må manuelt legges til ved registrering av utenlandske selskaper.",
    "screening.infobox.roles.text.norwegian": "Vi identifiserer personer som, ved tidspunktet for registreringen, er registrert med roller i selskapet (kilde: Brønnøysundregistrene).",
    "screening.infobox.roles.title": "Hva er en rolleinnehaver?",
    "screening.messages.retrieving-details": "Henter kundedata",
    "screening.messages.specify-owners": "Oppgi selskapets rettighetshavere",
    "screening.messages.specify-roles": "Oppgi selskapets rolleinnehavere",
    "screening.owners.is_ubo.description": "Denne personen eier mer enn 25% av aksjene i kunden (eller mer enn 25% av aksjene i et selskap som eier mer enn 25% av kunden, etc.), som indikerer at personen er å anse som reell rettighetshaver. Se Hvitvaskingsloven: https://lovdata.no/lov/2018-06-01-23/§14",
    "screening.roles.is_ubo.description": "I denne typen foretak ({companyType}) kan denne rollen ({roleType}) være en alternativ reell rettighetshaver.",
    "screening.snackbar.started": "Ny screening startet",
    "screening.snackbar.stopped": "Screening avsluttet",
    "screening.snackbar.updated": "Screening endret",
    "screening.status.active": "Aktiv",
    "screening.status.finished": "(utført {finished, date, ::yyyyMMdd})",
    "screening.status.range": "(startet {started, date, ::yyyyMMdd}, avsluttet {stopped, date, ::yyyyMMdd})",
    "screening.titles.banner.description": "Kunden vil ikke bli varslet om at du foretar en screening.",
    "screening.titles.banner.title": "Screeningen gjøres ubemerket.",
    "screening.titles.customer": "Kunde",
    "screening.titles.owners": "Rettighetshavere",
    "screening.titles.roles": "Rolleinnehavere",
    "screening.titles.screening": "Screening",
    "screening.titles.screening-frequency": "Velg type screening",
    "screening.titles.screening.description": "Velg personene som screeningen skal utføres på. Personene som er presentert består av rettighetshavere med 5 prosent eller høyere eierandel og identifiserte rolleinnhavere.",
    "screening.titles.screening.manual.description": "Legg til rettighetshavere og rolleinnehavere tilhørende selskapskunden du skal registrere. Husk å krysse av alle som skal inkluderes i screeningen.",
    "screening.titles.screening.without-shareholders.description": "Velg personene som screeningen skal utføres på. Personene som er presentert består av identifiserte rolleinnhavere.",
    "shares-classes.banner.description": "Det er identifisert flere aksjeklasser i {name}. Vær oppmerksom på at en person kan ha stemmerettigheter utover de som følger av eierandelen når det er utstedt ulike aksjeklasser med ulik stemmerett (f.eks. A- og B-aksjer). Dette kan ha betydning for hvem som er å anse som reell(e) rettighetshaver(e). Du bør derfor innhente vedtektene fra din kunde og undersøke dette.",
    "shares-classes.banner.title": "Flere aksjeklasser identifisert: {shares}",
    "shares-classes.banner.url-label": "Les mer på vår supportportal",
    "signature.actions.copy.link": "Kopier link",
    "signature.actions.delete.signature": "Slett KYC-forespørsel",
    "signature.actions.edit.signature": "Rediger mottakerinfo",
    "signature.actions.remind.signer": "Påminn mottaker",
    "signature.configuration.form.buttons.preview": "Se hvordan KYC-skjemaet ser ut for kunden",
    "signature.configuration.form.labels.choose.language": "Velg språk på e-post og KYC-spørsmål",
    "signature.configuration.form.labels.choose.send.method": "Velg sendemetode",
    "signature.configuration.form.labels.custom.kyc.questions": "Egendefinerte KYC-spørsmål",
    "signature.configuration.form.labels.disclosure": "KYC-spørsmål",
    "signature.configuration.form.labels.disclosure.full": "Full KYC (inkl. PEP-spørsmål)",
    "signature.configuration.form.labels.disclosure.pep": "Kun PEP-spørsmål",
    "signature.configuration.form.labels.e-signatures": "Send dokument til e-signering",
    "signature.configuration.form.labels.preview": "Forhåndsvisning av KYC",
    "signature.configuration.form.labels.verification": "Inkluder legitimasjon med:",
    "signature.email.not.provided": "Link tilgjengelig på kundesiden",
    "signature.modal.and.tooltips.copy.link": "Kopier signeringslink",
    "signature.signing-method.no": "Norsk BankID",
    "signature.signing-method.se": "Svensk BankID",
    "signature.snackbar.deleted": "KYC-forespørsel slettet",
    "signature.tooltips.remind.signer": "Påminn mottaker",
    "signing-user-info.address": "Adresse",
    "signing-user-info.birth-date": "Fødselsdato",
    "signing-user-info.name.mismatch.warning.tooltip": "Er dette riktig person?",
    "summary.description": "Se over oppsummeringen og gjør endringer hvis nødvendig. Når du starter screeningen vil kunden motta en lenke med elektronisk identifisering og KYC-spørsmål.",
    "summary.project.title": "Prosjekt",
    "summary.responsible-user": "Ansvarlig",
    "summary.screening-type": "Type screening",
    "summary.signers.start.screening": "Registrer kunde og start screening",
    "summary.signers.text.skipped": "Dette steget er blitt hoppet over",
    "summary.signers.title": "Mottakere av legitimering og KYC-spørsmål",
    "summary.signers.title.empty": "Ingen representanter valgt",
    "summary.text.no-owners": "Ingen rettighetshavere blir screenet",
    "summary.text.no-roles": "Ingen rolleinnehavere blir screenet",
    "summary.text.screening.company": "Screening av selskap",
    "summary.text.screening.owners": "Screening av rettighetshavere",
    "summary.text.screening.roles": "Screening av rolleinnehavere",
    "table.column.active": "AKTIV",
    "table.column.address": "ADRESSE",
    "table.column.country": "LAND",
    "table.column.customer-number": "PERSONNUMMER / ORG.NR",
    "table.column.customerTypes": "KUNDETYPER",
    "table.column.date.of.birth": "FØDSELSDATO",
    "table.column.details": "DETALJER",
    "table.column.email": "E-POST",
    "table.column.email.or.url": "E-POST/LINK",
    "table.column.gender": "KJØNN",
    "table.column.groups": "GRUPPER",
    "table.column.id": "ID",
    "table.column.ignore": "OVERSE",
    "table.column.last.updated": "SIST OPPDATERT",
    "table.column.link": "LENKE",
    "table.column.measure": "TILTAK",
    "table.column.name": "NAVN",
    "table.column.name-from-search": "NAVN FRA OPPSLAG",
    "table.column.name-on-match": "NAVN PÅ TREFF",
    "table.column.national.id": "FØDSELSNUMMER",
    "table.column.person": "PERSON",
    "table.column.pin": "PIN",
    "table.column.previous-search": "TIDLIGERE SØK",
    "table.column.questions": "SPØRSMÅL",
    "table.column.required": "OBLIGATORISK",
    "table.column.responsible-user": "ANSVARLIG BRUKER",
    "table.column.role": "ROLLE",
    "table.column.search-by": "SØKT PÅ AV",
    "table.column.shares": "EIERANDEL",
    "table.column.status": "STATUS",
    "table.column.time-of-search": "TIDSPUNKT FOR SØK",
    "table.column.title": "TITTEL",
    "table.column.ubo": "AKSJONÆR",
    "table.column.used": "BENYTTES",
    "table.row.owner": "Aksjonær",
    "tags.button.label": "Tags",
    "tags.editor.add-and-apply-button": "Opprett og tildel «{tag}»",
    "tags.editor.existing-tags": "Eksisterende tags",
    "tags.editor.filter-tags": "Filtrer på tags:",
    "tags.editor.new-tag-input": "Opprett tag",
    "tags.modal.empty-state": "Du har ikke opprettet noen tags.",
    "tags.modal.tag.color": "Velg farge på tag",
    "tags.modal.tag.delete-tag": "Slett tag",
    "tags.modal.tag.delete-tag.description": "Sletter du tag «Bingo» fjernes den også fra alle prosjekter og tilhørende kunder.",
    "tags.modal.tag.name": "Navngi tag på {language}",
    "tags.modal.tag.placeholder": "Navngi tag",
    "tags.modal.tag.validation-error": "Angi navn på tag",
    "tags.modal.title.add-tag": "Opprett tag",
    "tags.modal.title.edit-tags": "Endre tags",
    "tags.modal.title.update-tag": "Endre tag",
    "tags.page.assigned-tag.delete.description": "Tags i bruk kan ikke slettes",
    "tags.page.filter.placeholder": "Søk etter tag",
    "tags.page.subtitle": "Opprett tags for enkelt å kunne gruppere kunder/klienter. Tags kan enkelt legges til en hvilken som helst kunde/klient og filtreres på både i kundelisten og på dashboard.",
    "tags.page.title": "Organiser med tags",
    "tags.popover.success.message": "Tildelt etikett",
    "ubo.manual-override.description": "Endringer bør begrunnes i kommentarfeltet under.\n(Du må endre screeningen manuelt ved behov, f.eks. hvis nye reelle rettighetshavere skal screenes)",
    "ubo.manual-override.title": "Personen er reell rettighetshaver",
    "users.modal.empty-group": "Ingen gruppe",
    "users.modal.label.activate": "Aktivere",
    "users.modal.label.deactivate": "Deaktivere",
    "users.modal.title.add-user": "Opprett bruker",
    "users.modal.title.update-user": "Oppdater bruker",
    "users.page.add-user.button-label": "Opprett bruker",
    "users.page.filter.hide-inactive-users": "Skjul deaktiverte brukere ({count, number})",
    "users.page.filter.placeholder": "Filtrér brukere etter navn",
    "users.page.filter.show-inactive-users": "Vis deaktiverte brukere ({count, number})",
    "users.page.table.empty": "Ingen brukere ble funnet",
    "users.page.title": "Brukere",
    "vitec.modal.banner.description": "Denne personen har ingen mobilnummer oppført. Vitec Next krever vedkommendes mobilnummer for at kontaktkortet kan importeres.",
    "vitec.modal.toast.message.error": "Kunne ikke importere {name} til Vitec Next ({error})",
    "vitec.modal.toast.message.success": "{name} ble lastet opp til Vitec Next",
    "vitec.report.upload.status.COMPLETED": "Lastet opp til Vitec",
    "vitec.report.upload.status.FAILED": "Opplasting feilet",
    "vitec.report.upload.status.WAITING": "Venter vurdering"
}
